// This file is auto-generated by @hey-api/openapi-ts

import {
  type Options as ClientOptions,
  type TDataShape,
  type Client,
  formDataBodySerializer,
} from './client';
import type {
  TriggerErrorSentryDebugExceptionGetData,
  TriggerErrorSentryDebugExceptionGetResponses,
  LogErrorSentryDebugLogErrorGetData,
  LogErrorSentryDebugLogErrorGetResponses,
  HealthCheckHealthGetData,
  HealthCheckHealthGetResponses,
  LoginAuthLoginGetData,
  LoginAuthLoginGetResponses,
  AuthCallbackAuthCallbackGetData,
  AuthCallbackAuthCallbackGetResponses,
  AuthCallbackAuthCallbackGetErrors,
  LogoutAuthLogoutGetData,
  LogoutAuthLogoutGetResponses,
  GetCurrentCtxInfoAuthMeGetData,
  GetCurrentCtxInfoAuthMeGetResponses,
  GetWidgetTokenAuthWidgetTokenGetData,
  GetWidgetTokenAuthWidgetTokenGetResponses,
  SwitchOrganizationAuthSwitchOrganizationPostData,
  SwitchOrganizationAuthSwitchOrganizationPostResponses,
  SwitchOrganizationAuthSwitchOrganizationPostErrors,
  GetUserOrganizationsAuthOrganizationsGetData,
  GetUserOrganizationsAuthOrganizationsGetResponses,
  GetIntakesForAuthManagementAuthorizationGetData,
  GetIntakesForAuthManagementAuthorizationGetResponses,
  GetIntakesForAuthManagementAuthorizationGetErrors,
  SimulateAuthorizationRequestAuthorizationSimulateIntakeIdRequestPostData,
  SimulateAuthorizationRequestAuthorizationSimulateIntakeIdRequestPostResponses,
  SimulateAuthorizationRequestAuthorizationSimulateIntakeIdRequestPostErrors,
  SimulateAuthorizationApproveAuthorizationSimulateIntakeIdApprovePostData,
  SimulateAuthorizationApproveAuthorizationSimulateIntakeIdApprovePostResponses,
  SimulateAuthorizationApproveAuthorizationSimulateIntakeIdApprovePostErrors,
  SimulateAuthorizationDenyAuthorizationSimulateIntakeIdDenyPostData,
  SimulateAuthorizationDenyAuthorizationSimulateIntakeIdDenyPostResponses,
  SimulateAuthorizationDenyAuthorizationSimulateIntakeIdDenyPostErrors,
  SimulateAuthorizationClearAuthorizationSimulateIntakeIdClearPostData,
  SimulateAuthorizationClearAuthorizationSimulateIntakeIdClearPostResponses,
  SimulateAuthorizationClearAuthorizationSimulateIntakeIdClearPostErrors,
  GetUsersUsersGetData,
  GetUsersUsersGetResponses,
  GetUsersUsersGetErrors,
  CreateUserUsersPostData,
  CreateUserUsersPostResponses,
  CreateUserUsersPostErrors,
  GetUsersByWorkosRolesUsersByWorkosRolesPostData,
  GetUsersByWorkosRolesUsersByWorkosRolesPostResponses,
  GetUsersByWorkosRolesUsersByWorkosRolesPostErrors,
  DeleteUserUsersUserIdDeleteData,
  DeleteUserUsersUserIdDeleteResponses,
  DeleteUserUsersUserIdDeleteErrors,
  GetUserUsersUserIdGetData,
  GetUserUsersUserIdGetResponses,
  GetUserUsersUserIdGetErrors,
  UpdateUserUsersUserIdPutData,
  UpdateUserUsersUserIdPutResponses,
  UpdateUserUsersUserIdPutErrors,
  ListOrgMembersUsersOrgMembersGetData,
  ListOrgMembersUsersOrgMembersGetResponses,
  SyncClinicAssignmentsUsersUserIdClinicAssignmentsPutData,
  SyncClinicAssignmentsUsersUserIdClinicAssignmentsPutResponses,
  SyncClinicAssignmentsUsersUserIdClinicAssignmentsPutErrors,
  AssignUserToAllClinicsUsersUserIdAssignAllClinicsPostData,
  AssignUserToAllClinicsUsersUserIdAssignAllClinicsPostResponses,
  AssignUserToAllClinicsUsersUserIdAssignAllClinicsPostErrors,
  GetUserClinicsUserClinicsGetData,
  GetUserClinicsUserClinicsGetResponses,
  GetUserClinicsUserClinicsGetErrors,
  CreateUserClinicUserClinicsPostData,
  CreateUserClinicUserClinicsPostResponses,
  CreateUserClinicUserClinicsPostErrors,
  DeleteUserClinicUserClinicsIdDeleteData,
  DeleteUserClinicUserClinicsIdDeleteResponses,
  DeleteUserClinicUserClinicsIdDeleteErrors,
  GetUserClinicUserClinicsIdGetData,
  GetUserClinicUserClinicsIdGetResponses,
  GetUserClinicUserClinicsIdGetErrors,
  GetClinicsByUserUserClinicsUserUserIdGetData,
  GetClinicsByUserUserClinicsUserUserIdGetResponses,
  GetClinicsByUserUserClinicsUserUserIdGetErrors,
  GetUsersByClinicUserClinicsClinicClinicIdGetData,
  GetUsersByClinicUserClinicsClinicClinicIdGetResponses,
  GetUsersByClinicUserClinicsClinicClinicIdGetErrors,
  RemoveUserFromClinicUserClinicsUserUserIdClinicClinicIdDeleteData,
  RemoveUserFromClinicUserClinicsUserUserIdClinicClinicIdDeleteResponses,
  RemoveUserFromClinicUserClinicsUserUserIdClinicClinicIdDeleteErrors,
  AddUserToAllAgencyClinicsUserClinicsUserUserIdAssignAllPostData,
  AddUserToAllAgencyClinicsUserClinicsUserUserIdAssignAllPostResponses,
  AddUserToAllAgencyClinicsUserClinicsUserUserIdAssignAllPostErrors,
  GetAvailableCliniciansUserClinicsAvailableGetData,
  GetAvailableCliniciansUserClinicsAvailableGetResponses,
  GetAvailableCliniciansUserClinicsAvailableGetErrors,
  GetAgenciesAgenciesGetData,
  GetAgenciesAgenciesGetResponses,
  GetAgenciesAgenciesGetErrors,
  CreateAgencyAgenciesPostData,
  CreateAgencyAgenciesPostResponses,
  CreateAgencyAgenciesPostErrors,
  DeleteAgencyAgenciesAgencyIdDeleteData,
  DeleteAgencyAgenciesAgencyIdDeleteResponses,
  DeleteAgencyAgenciesAgencyIdDeleteErrors,
  GetAgencyAgenciesAgencyIdGetData,
  GetAgencyAgenciesAgencyIdGetResponses,
  GetAgencyAgenciesAgencyIdGetErrors,
  UpdateAgencyAgenciesAgencyIdPutData,
  UpdateAgencyAgenciesAgencyIdPutResponses,
  UpdateAgencyAgenciesAgencyIdPutErrors,
  GetAgencyClinicsAgencyClinicsGetData,
  GetAgencyClinicsAgencyClinicsGetResponses,
  GetAgencyClinicsAgencyClinicsGetErrors,
  CreateAgencyClinicAgencyClinicsPostData,
  CreateAgencyClinicAgencyClinicsPostResponses,
  CreateAgencyClinicAgencyClinicsPostErrors,
  DeleteAgencyClinicAgencyClinicsAgencyClinicIdDeleteData,
  DeleteAgencyClinicAgencyClinicsAgencyClinicIdDeleteResponses,
  DeleteAgencyClinicAgencyClinicsAgencyClinicIdDeleteErrors,
  GetAgencyClinicAgencyClinicsAgencyClinicIdGetData,
  GetAgencyClinicAgencyClinicsAgencyClinicIdGetResponses,
  GetAgencyClinicAgencyClinicsAgencyClinicIdGetErrors,
  UpdateAgencyClinicAgencyClinicsAgencyClinicIdPutData,
  UpdateAgencyClinicAgencyClinicsAgencyClinicIdPutResponses,
  UpdateAgencyClinicAgencyClinicsAgencyClinicIdPutErrors,
  SyncClinicsFromClinicInfoAgencyClinicsSyncFromClinicInfoPostData,
  SyncClinicsFromClinicInfoAgencyClinicsSyncFromClinicInfoPostResponses,
  GetClinicInfoClinicsInfoAgencyIdGetData,
  GetClinicInfoClinicsInfoAgencyIdGetResponses,
  GetClinicInfoClinicsInfoAgencyIdGetErrors,
  ScrapeClinicInfoClinicsInfoScrapePostData,
  ScrapeClinicInfoClinicsInfoScrapePostResponses,
  ScrapeClinicInfoClinicsInfoScrapePostErrors,
  GetAgencyInsurancesClinicsInsuranceGetData,
  GetAgencyInsurancesClinicsInsuranceGetResponses,
  GetAgencyInsurancesClinicsInsuranceGetErrors,
  UpdateInsurancesFromClinicInfoClinicsInsuranceUpdateFromClinicInfoPostData,
  UpdateInsurancesFromClinicInfoClinicsInsuranceUpdateFromClinicInfoPostResponses,
  UpdateInsurancesFromClinicInfoClinicsInsuranceUpdateFromClinicInfoPostErrors,
  GetPatientsPatientsGetData,
  GetPatientsPatientsGetResponses,
  GetPatientsPatientsGetErrors,
  CreatePatientPatientsPostData,
  CreatePatientPatientsPostResponses,
  CreatePatientPatientsPostErrors,
  GetPatientCountPatientsCountGetData,
  GetPatientCountPatientsCountGetResponses,
  DeletePatientPatientsPatientIdDeleteData,
  DeletePatientPatientsPatientIdDeleteResponses,
  DeletePatientPatientsPatientIdDeleteErrors,
  GetPatientPatientsPatientIdGetData,
  GetPatientPatientsPatientIdGetResponses,
  GetPatientPatientsPatientIdGetErrors,
  UpdatePatientPatientsPatientIdPutData,
  UpdatePatientPatientsPatientIdPutResponses,
  UpdatePatientPatientsPatientIdPutErrors,
  GetPatientVisitsPatientsPatientIdVisitsGetData,
  GetPatientVisitsPatientsPatientIdVisitsGetResponses,
  GetPatientVisitsPatientsPatientIdVisitsGetErrors,
  CreatePatientVisitPatientsPatientIdVisitsPostData,
  CreatePatientVisitPatientsPatientIdVisitsPostResponses,
  CreatePatientVisitPatientsPatientIdVisitsPostErrors,
  GetPatientDocumentsPatientsPatientIdDocumentsGetData,
  GetPatientDocumentsPatientsPatientIdDocumentsGetResponses,
  GetPatientDocumentsPatientsPatientIdDocumentsGetErrors,
  UploadPatientDocumentPatientsPatientIdDocumentsPostData,
  UploadPatientDocumentPatientsPatientIdDocumentsPostResponses,
  UploadPatientDocumentPatientsPatientIdDocumentsPostErrors,
  GetPatientDocumentUrlPatientsPatientIdDocumentsDocumentIdUrlGetData,
  GetPatientDocumentUrlPatientsPatientIdDocumentsDocumentIdUrlGetResponses,
  GetPatientDocumentUrlPatientsPatientIdDocumentsDocumentIdUrlGetErrors,
  UpdatePatientDocumentPatientsPatientIdDocumentsDocumentIdPatchData,
  UpdatePatientDocumentPatientsPatientIdDocumentsDocumentIdPatchResponses,
  UpdatePatientDocumentPatientsPatientIdDocumentsDocumentIdPatchErrors,
  ImportWaystarCsvEndpointPayorsImportWaystarCsvPostData,
  ImportWaystarCsvEndpointPayorsImportWaystarCsvPostResponses,
  ImportStediCsvEndpointPayorsImportStediCsvPostData,
  ImportStediCsvEndpointPayorsImportStediCsvPostResponses,
  GetPayorsEndpointPayorsGetData,
  GetPayorsEndpointPayorsGetResponses,
  GetPayorsEndpointPayorsGetErrors,
  CreatePayorEndpointPayorsPostData,
  CreatePayorEndpointPayorsPostResponses,
  CreatePayorEndpointPayorsPostErrors,
  DeletePayorEndpointPayorsPayorIdDeleteData,
  DeletePayorEndpointPayorsPayorIdDeleteResponses,
  DeletePayorEndpointPayorsPayorIdDeleteErrors,
  GetPayorEndpointPayorsPayorIdGetData,
  GetPayorEndpointPayorsPayorIdGetResponses,
  GetPayorEndpointPayorsPayorIdGetErrors,
  UpdatePayorEndpointPayorsPayorIdPutData,
  UpdatePayorEndpointPayorsPayorIdPutResponses,
  UpdatePayorEndpointPayorsPayorIdPutErrors,
  GetPayorByNameEndpointPayorsByNamePayorNameGetData,
  GetPayorByNameEndpointPayorsByNamePayorNameGetResponses,
  GetPayorByNameEndpointPayorsByNamePayorNameGetErrors,
  GetPayorByElectronicIdEndpointPayorsByElectronicIdElectronicPayorIdGetData,
  GetPayorByElectronicIdEndpointPayorsByElectronicIdElectronicPayorIdGetResponses,
  GetPayorByElectronicIdEndpointPayorsByElectronicIdElectronicPayorIdGetErrors,
  GetPayorByClearinghouseIdEndpointPayorsByClearinghouseIdClearinghousePayorIdGetData,
  GetPayorByClearinghouseIdEndpointPayorsByClearinghouseIdClearinghousePayorIdGetResponses,
  GetPayorByClearinghouseIdEndpointPayorsByClearinghouseIdClearinghousePayorIdGetErrors,
  GetEligibilityChecksEndpointEligibilityGetData,
  GetEligibilityChecksEndpointEligibilityGetResponses,
  GetEligibilityChecksEndpointEligibilityGetErrors,
  CreateEligibilityCheckEndpointEligibilityPostData,
  CreateEligibilityCheckEndpointEligibilityPostResponses,
  CreateEligibilityCheckEndpointEligibilityPostErrors,
  DeleteEligibilityCheckEndpointEligibilityEligibilityIdDeleteData,
  DeleteEligibilityCheckEndpointEligibilityEligibilityIdDeleteResponses,
  DeleteEligibilityCheckEndpointEligibilityEligibilityIdDeleteErrors,
  GetEligibilityCheckEndpointEligibilityEligibilityIdGetData,
  GetEligibilityCheckEndpointEligibilityEligibilityIdGetResponses,
  GetEligibilityCheckEndpointEligibilityEligibilityIdGetErrors,
  UpdateEligibilityCheckEndpointEligibilityEligibilityIdPutData,
  UpdateEligibilityCheckEndpointEligibilityEligibilityIdPutResponses,
  UpdateEligibilityCheckEndpointEligibilityEligibilityIdPutErrors,
  CompleteEligibilityCheckEndpointEligibilityEligibilityIdCompletePostData,
  CompleteEligibilityCheckEndpointEligibilityEligibilityIdCompletePostResponses,
  CompleteEligibilityCheckEndpointEligibilityEligibilityIdCompletePostErrors,
  SimulateEligibilityCheckEligibilitySimulateIntakeIdCheckPostData,
  SimulateEligibilityCheckEligibilitySimulateIntakeIdCheckPostResponses,
  SimulateEligibilityCheckEligibilitySimulateIntakeIdCheckPostErrors,
  SimulateEligibilityCompleteEligibilitySimulateIntakeIdCompletePostData,
  SimulateEligibilityCompleteEligibilitySimulateIntakeIdCompletePostResponses,
  SimulateEligibilityCompleteEligibilitySimulateIntakeIdCompletePostErrors,
  SimulateEligibilityFailEligibilitySimulateIntakeIdFailPostData,
  SimulateEligibilityFailEligibilitySimulateIntakeIdFailPostResponses,
  SimulateEligibilityFailEligibilitySimulateIntakeIdFailPostErrors,
  PerformRealEligibilityCheckEligibilityIntakeIntakeIdCheckPostData,
  PerformRealEligibilityCheckEligibilityIntakeIntakeIdCheckPostResponses,
  PerformRealEligibilityCheckEligibilityIntakeIntakeIdCheckPostErrors,
  GetBucketStatusS3BucketStatusGetData,
  GetBucketStatusS3BucketStatusGetResponses,
  StartSimpleWorkflowTemporalWorkflowSimplePostData,
  StartSimpleWorkflowTemporalWorkflowSimplePostResponses,
  StartSimpleWorkflowTemporalWorkflowSimplePostErrors,
  StartDataProcessingWorkflowTemporalWorkflowDataProcessingPostData,
  StartDataProcessingWorkflowTemporalWorkflowDataProcessingPostResponses,
  StartDataProcessingWorkflowTemporalWorkflowDataProcessingPostErrors,
  HealthCheckTemporalHealthGetData,
  HealthCheckTemporalHealthGetResponses,
  GetIntakeFormSchemaIntakeFormSchemaGetData,
  GetIntakeFormSchemaIntakeFormSchemaGetResponses,
  GetIntakeExtractionPromptIntakeExtractionPromptGetData,
  GetIntakeExtractionPromptIntakeExtractionPromptGetResponses,
  UploadFileAndCreateIntakeIntakeUploadPostData,
  UploadFileAndCreateIntakeIntakeUploadPostResponses,
  UploadFileAndCreateIntakeIntakeUploadPostErrors,
  UploadMultipleFilesAndCreateIntakeIntakeUploadMultiplePostData,
  UploadMultipleFilesAndCreateIntakeIntakeUploadMultiplePostResponses,
  UploadMultipleFilesAndCreateIntakeIntakeUploadMultiplePostErrors,
  GetAuthQueueEndpointIntakeAuthQueueGetData,
  GetAuthQueueEndpointIntakeAuthQueueGetResponses,
  GetAuthQueueEndpointIntakeAuthQueueGetErrors,
  DeleteIntakeEndpointIntakeIntakeIdDeleteData,
  DeleteIntakeEndpointIntakeIntakeIdDeleteResponses,
  DeleteIntakeEndpointIntakeIntakeIdDeleteErrors,
  GetIntakeEndpointIntakeIntakeIdGetData,
  GetIntakeEndpointIntakeIntakeIdGetResponses,
  GetIntakeEndpointIntakeIntakeIdGetErrors,
  UpdateIntakeEndpointIntakeIntakeIdPutData,
  UpdateIntakeEndpointIntakeIntakeIdPutResponses,
  UpdateIntakeEndpointIntakeIntakeIdPutErrors,
  GetIntakeProcessingStatusIntakeIntakeIdProcessingStatusGetData,
  GetIntakeProcessingStatusIntakeIntakeIdProcessingStatusGetResponses,
  GetIntakeProcessingStatusIntakeIntakeIdProcessingStatusGetErrors,
  GetIntakesEndpointIntakeGetData,
  GetIntakesEndpointIntakeGetResponses,
  GetIntakesEndpointIntakeGetErrors,
  InitializeEmrSelectionEndpointIntakeIntakeIdInitializeEmrSelectionPostData,
  InitializeEmrSelectionEndpointIntakeIntakeIdInitializeEmrSelectionPostResponses,
  InitializeEmrSelectionEndpointIntakeIntakeIdInitializeEmrSelectionPostErrors,
  UpdateIntakeFieldsEndpointIntakeIntakeIdFieldsPatchData,
  UpdateIntakeFieldsEndpointIntakeIntakeIdFieldsPatchResponses,
  UpdateIntakeFieldsEndpointIntakeIntakeIdFieldsPatchErrors,
  UpdateIntakeStatusEndpointIntakeIntakeIdStatusPutData,
  UpdateIntakeStatusEndpointIntakeIntakeIdStatusPutResponses,
  UpdateIntakeStatusEndpointIntakeIntakeIdStatusPutErrors,
  RejectIntakeEndpointIntakeIntakeIdRejectPutData,
  RejectIntakeEndpointIntakeIntakeIdRejectPutResponses,
  RejectIntakeEndpointIntakeIntakeIdRejectPutErrors,
  ConfirmTabStatusEndpointIntakeIntakeIdTabTabKeyConfirmPutData,
  ConfirmTabStatusEndpointIntakeIntakeIdTabTabKeyConfirmPutResponses,
  ConfirmTabStatusEndpointIntakeIntakeIdTabTabKeyConfirmPutErrors,
  GetReferralDocPresignedUrlIntakeIntakeIdReferralDocGetData,
  GetReferralDocPresignedUrlIntakeIntakeIdReferralDocGetResponses,
  GetReferralDocPresignedUrlIntakeIntakeIdReferralDocGetErrors,
  GetReferralDocsPresignedUrlsIntakeIntakeIdReferralDocsGetData,
  GetReferralDocsPresignedUrlsIntakeIntakeIdReferralDocsGetResponses,
  GetReferralDocsPresignedUrlsIntakeIntakeIdReferralDocsGetErrors,
  GetIntakeDocumentsNameDictIntakeIntakeIdDocumentsNameDictGetData,
  GetIntakeDocumentsNameDictIntakeIntakeIdDocumentsNameDictGetResponses,
  GetIntakeDocumentsNameDictIntakeIntakeIdDocumentsNameDictGetErrors,
  UpdateIntakeDocumentIntakeDocumentsDocumentIdPatchData,
  UpdateIntakeDocumentIntakeDocumentsDocumentIdPatchResponses,
  UpdateIntakeDocumentIntakeDocumentsDocumentIdPatchErrors,
  UploadDocumentToIntakeIntakeIntakeIdDocumentsPostData,
  UploadDocumentToIntakeIntakeIntakeIdDocumentsPostResponses,
  UploadDocumentToIntakeIntakeIntakeIdDocumentsPostErrors,
  TriggerAiAnalysisEndpointIntakeIntakeIdTriggerAiAnalysisPostData,
  TriggerAiAnalysisEndpointIntakeIntakeIdTriggerAiAnalysisPostResponses,
  TriggerAiAnalysisEndpointIntakeIntakeIdTriggerAiAnalysisPostErrors,
  ReprocessIntakeEndpointIntakeIntakeIdReprocessPostData,
  ReprocessIntakeEndpointIntakeIntakeIdReprocessPostResponses,
  ReprocessIntakeEndpointIntakeIntakeIdReprocessPostErrors,
  GetAiAnalysisEndpointIntakeIntakeIdAiAnalysisGetData,
  GetAiAnalysisEndpointIntakeIntakeIdAiAnalysisGetResponses,
  GetAiAnalysisEndpointIntakeIntakeIdAiAnalysisGetErrors,
  GetEpisodeDetailsEndpointIntakeIntakeIdEpisodeDetailsGetData,
  GetEpisodeDetailsEndpointIntakeIntakeIdEpisodeDetailsGetResponses,
  GetEpisodeDetailsEndpointIntakeIntakeIdEpisodeDetailsGetErrors,
  OnboardPatientRogerIntakeIntakeIdOnboardPatientRogerPostData,
  OnboardPatientRogerIntakeIntakeIdOnboardPatientRogerPostResponses,
  OnboardPatientRogerIntakeIntakeIdOnboardPatientRogerPostErrors,
  GetVisitsByClinicianVisitsByClinicianClinicianIdGetData,
  GetVisitsByClinicianVisitsByClinicianClinicianIdGetResponses,
  GetVisitsByClinicianVisitsByClinicianClinicianIdGetErrors,
  DeleteVisitVisitsVisitIdDeleteData,
  DeleteVisitVisitsVisitIdDeleteResponses,
  DeleteVisitVisitsVisitIdDeleteErrors,
  GetVisitVisitsVisitIdGetData,
  GetVisitVisitsVisitIdGetResponses,
  GetVisitVisitsVisitIdGetErrors,
  UpdateVisitVisitsVisitIdPutData,
  UpdateVisitVisitsVisitIdPutResponses,
  UpdateVisitVisitsVisitIdPutErrors,
  CreateVisitVisitsPostData,
  CreateVisitVisitsPostResponses,
  CreateVisitVisitsPostErrors,
  GetVisitDataVisitsVisitIdDataGetData,
  GetVisitDataVisitsVisitIdDataGetResponses,
  GetVisitDataVisitsVisitIdDataGetErrors,
  UpdateVisitDataVisitsVisitIdDataPutData,
  UpdateVisitDataVisitsVisitIdDataPutResponses,
  UpdateVisitDataVisitsVisitIdDataPutErrors,
  GetQuestionSchemaRogerdocQuestionSchemaGetData,
  GetQuestionSchemaRogerdocQuestionSchemaGetResponses,
  GetQuestionSchemaRogerdocQuestionSchemaGetErrors,
  CheckRogerdocHealthRogerdocHealthGetData,
  CheckRogerdocHealthRogerdocHealthGetResponses,
  GetCodingUploadUrlsRogerdocCodingUploadUrlsPostData,
  GetCodingUploadUrlsRogerdocCodingUploadUrlsPostResponses,
  GetCodingUploadUrlsRogerdocCodingUploadUrlsPostErrors,
  UploadCodingFilesRogerdocCodingUploadFilesPostData,
  UploadCodingFilesRogerdocCodingUploadFilesPostResponses,
  UploadCodingFilesRogerdocCodingUploadFilesPostErrors,
  SetPatientInfoRogerdocCodingSetPatientInfoPostData,
  SetPatientInfoRogerdocCodingSetPatientInfoPostResponses,
  SetPatientInfoRogerdocCodingSetPatientInfoPostErrors,
  RogerdocVspUpdateData,
  RogerdocVspUpdateResponses,
  RogerdocPassthroughDeleteData,
  RogerdocPassthroughDeleteResponses,
  RogerdocPassthroughDeleteErrors,
  RogerdocPassthroughGetData,
  RogerdocPassthroughGetResponses,
  RogerdocPassthroughGetErrors,
  RogerdocPassthroughPatchData,
  RogerdocPassthroughPatchResponses,
  RogerdocPassthroughPatchErrors,
  RogerdocPassthroughPostData,
  RogerdocPassthroughPostResponses,
  RogerdocPassthroughPostErrors,
  RogerdocPassthroughPutData,
  RogerdocPassthroughPutResponses,
  RogerdocPassthroughPutErrors,
  GenerateX12270X12270GeneratePostData,
  GenerateX12270X12270GeneratePostResponses,
  GenerateX12270X12270GeneratePostErrors,
  CheckEligibilityWithX12270X12270EligibilityCheckPostData,
  CheckEligibilityWithX12270X12270EligibilityCheckPostResponses,
  CheckEligibilityWithX12270X12270EligibilityCheckPostErrors,
  GenerateX12271X12271GeneratePostData,
  GenerateX12271X12271GeneratePostResponses,
  GenerateX12271X12271GeneratePostErrors,
  ParseX12271X12271ParsePostData,
  ParseX12271X12271ParsePostResponses,
  ParseX12271X12271ParsePostErrors,
  GenerateX12837iX12837iGeneratePostData,
  GenerateX12837iX12837iGeneratePostResponses,
  GenerateX12837iX12837iGeneratePostErrors,
  CheckEligibilityX12WaystarEligibilityPostData,
  CheckEligibilityX12WaystarEligibilityPostResponses,
  CheckEligibilityX12WaystarEligibilityPostErrors,
  CheckEligibilityDirectWaystarEligibilityDirectPostData,
  CheckEligibilityDirectWaystarEligibilityDirectPostResponses,
  CheckEligibilityDirectWaystarEligibilityDirectPostErrors,
  CheckPriorAuthorizationWaystarPriorAuthPostData,
  CheckPriorAuthorizationWaystarPriorAuthPostResponses,
  CheckPriorAuthorizationWaystarPriorAuthPostErrors,
  SubmitClaimWaystarClaimsSubmit837iPostData,
  SubmitClaimWaystarClaimsSubmit837iPostResponses,
  SubmitClaimWaystarClaimsSubmit837iPostErrors,
  CheckClaimAcknowledgmentWaystarClaimsClaimIdAckGetData,
  CheckClaimAcknowledgmentWaystarClaimsClaimIdAckGetResponses,
  CheckClaimAcknowledgmentWaystarClaimsClaimIdAckGetErrors,
  CheckEligibilityStediEligibilityPostData,
  CheckEligibilityStediEligibilityPostResponses,
  CheckEligibilityStediEligibilityPostErrors,
  CheckCoordinationOfBenefitsStediCoordinationOfBenefitsPostData,
  CheckCoordinationOfBenefitsStediCoordinationOfBenefitsPostResponses,
  CheckCoordinationOfBenefitsStediCoordinationOfBenefitsPostErrors,
  SubmitClaim837iStediClaim837iPostData,
  SubmitClaim837iStediClaim837iPostResponses,
  SubmitClaim837iStediClaim837iPostErrors,
  UploadClaimDocumentForPatientStediPatientsPatientIdClaimDocumentsPostData,
  UploadClaimDocumentForPatientStediPatientsPatientIdClaimDocumentsPostResponses,
  UploadClaimDocumentForPatientStediPatientsPatientIdClaimDocumentsPostErrors,
  ReceiveStediWebhookStediWebhooksReceivePostData,
  ReceiveStediWebhookStediWebhooksReceivePostResponses,
  ReceiveStediWebhookStediWebhooksReceivePostErrors,
  CreatePatientInKinnserKinnserPatientsPostData,
  CreatePatientInKinnserKinnserPatientsPostResponses,
  CreatePatientInKinnserKinnserPatientsPostErrors,
  OnboardPatientKinnserPatientOnboardClinicIdBranchIdPostData,
  OnboardPatientKinnserPatientOnboardClinicIdBranchIdPostResponses,
  OnboardPatientKinnserPatientOnboardClinicIdBranchIdPostErrors,
  GetKinnserClinicDataKinnserClinicsClinicIdGetData,
  GetKinnserClinicDataKinnserClinicsClinicIdGetResponses,
  GetKinnserClinicDataKinnserClinicsClinicIdGetErrors,
  GetKinnserClinicsKinnserClinicsGetData,
  GetKinnserClinicsKinnserClinicsGetResponses,
  SearchAllergiesAllergiesGetData,
  SearchAllergiesAllergiesGetResponses,
  SearchAllergiesAllergiesGetErrors,
  CreateAllergyAllergiesPostData,
  CreateAllergyAllergiesPostResponses,
  CreateAllergyAllergiesPostErrors,
  GetUserDefinedAllergiesAllergiesUserDefinedGetData,
  GetUserDefinedAllergiesAllergiesUserDefinedGetResponses,
  ImportAllergiesFromFileAllergiesImportPostData,
  ImportAllergiesFromFileAllergiesImportPostResponses,
  DeleteAllergyAllergiesAllergyIdDeleteData,
  DeleteAllergyAllergiesAllergyIdDeleteResponses,
  DeleteAllergyAllergiesAllergyIdDeleteErrors,
  GetAllergyAllergiesAllergyIdGetData,
  GetAllergyAllergiesAllergyIdGetResponses,
  GetAllergyAllergiesAllergyIdGetErrors,
  GetPatientAllergiesPatientsPatientIdAllergyGetData,
  GetPatientAllergiesPatientsPatientIdAllergyGetResponses,
  GetPatientAllergiesPatientsPatientIdAllergyGetErrors,
  CreatePatientAllergyPatientsPatientIdAllergyPostData,
  CreatePatientAllergyPatientsPatientIdAllergyPostResponses,
  CreatePatientAllergyPatientsPatientIdAllergyPostErrors,
  CreateUserDefinedPatientAllergyPatientsPatientIdAllergyUserDefinedPostData,
  CreateUserDefinedPatientAllergyPatientsPatientIdAllergyUserDefinedPostResponses,
  CreateUserDefinedPatientAllergyPatientsPatientIdAllergyUserDefinedPostErrors,
  DeletePatientAllergyPatientsAllergyPatientAllergyIdDeleteData,
  DeletePatientAllergyPatientsAllergyPatientAllergyIdDeleteResponses,
  DeletePatientAllergyPatientsAllergyPatientAllergyIdDeleteErrors,
  SearchMedicationsEndpointMedicationsGetData,
  SearchMedicationsEndpointMedicationsGetResponses,
  SearchMedicationsEndpointMedicationsGetErrors,
  GetMedicationFormsEndpointMedicationsFormsGetData,
  GetMedicationFormsEndpointMedicationsFormsGetResponses,
  GetMedicationRoutesEndpointMedicationsRoutesGetData,
  GetMedicationRoutesEndpointMedicationsRoutesGetResponses,
  GetMedicationCategoriesEndpointMedicationsCategoriesGetData,
  GetMedicationCategoriesEndpointMedicationsCategoriesGetResponses,
  GetMedicationEndpointMedicationsMedicationIdGetData,
  GetMedicationEndpointMedicationsMedicationIdGetResponses,
  GetMedicationEndpointMedicationsMedicationIdGetErrors,
  GetPatientMedicationsPatientsPatientIdMedicationsGetData,
  GetPatientMedicationsPatientsPatientIdMedicationsGetResponses,
  GetPatientMedicationsPatientsPatientIdMedicationsGetErrors,
  CreatePatientMedicationPatientsPatientIdMedicationsPostData,
  CreatePatientMedicationPatientsPatientIdMedicationsPostResponses,
  CreatePatientMedicationPatientsPatientIdMedicationsPostErrors,
  DeletePatientMedicationPatientsPatientIdMedicationsMedicationIdDeleteData,
  DeletePatientMedicationPatientsPatientIdMedicationsMedicationIdDeleteResponses,
  DeletePatientMedicationPatientsPatientIdMedicationsMedicationIdDeleteErrors,
  GetPatientMedicationPatientsPatientIdMedicationsMedicationIdGetData,
  GetPatientMedicationPatientsPatientIdMedicationsMedicationIdGetResponses,
  GetPatientMedicationPatientsPatientIdMedicationsMedicationIdGetErrors,
  UpdatePatientMedicationPatientsPatientIdMedicationsMedicationIdPutData,
  UpdatePatientMedicationPatientsPatientIdMedicationsMedicationIdPutResponses,
  UpdatePatientMedicationPatientsPatientIdMedicationsMedicationIdPutErrors,
  GetMedicationProfileAttachmentsPatientsPatientIdMedicationsAttachmentsGetData,
  GetMedicationProfileAttachmentsPatientsPatientIdMedicationsAttachmentsGetResponses,
  GetMedicationProfileAttachmentsPatientsPatientIdMedicationsAttachmentsGetErrors,
  UploadMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsPostData,
  UploadMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsPostResponses,
  UploadMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsPostErrors,
  GetMedicationAttachmentUrlPatientsPatientIdMedicationsAttachmentsAttachmentIdUrlGetData,
  GetMedicationAttachmentUrlPatientsPatientIdMedicationsAttachmentsAttachmentIdUrlGetResponses,
  GetMedicationAttachmentUrlPatientsPatientIdMedicationsAttachmentsAttachmentIdUrlGetErrors,
  DeleteMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsAttachmentIdDeleteData,
  DeleteMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsAttachmentIdDeleteResponses,
  DeleteMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsAttachmentIdDeleteErrors,
  InternalHealthCheckInternalHealthGetData,
  InternalHealthCheckInternalHealthGetResponses,
  InternalHealthCheckInternalHealthGetErrors,
  SyncClinicsFromClinicInfoInternalInternalAgencyClinicsSyncFromClinicInfoPostData,
  SyncClinicsFromClinicInfoInternalInternalAgencyClinicsSyncFromClinicInfoPostResponses,
  SyncClinicsFromClinicInfoInternalInternalAgencyClinicsSyncFromClinicInfoPostErrors,
  GetVisitsListInternalInternalVisitsGetData,
  GetVisitsListInternalInternalVisitsGetResponses,
  GetVisitsListInternalInternalVisitsGetErrors,
  CreateVisitInternalInternalVisitsPostData,
  CreateVisitInternalInternalVisitsPostResponses,
  CreateVisitInternalInternalVisitsPostErrors,
  GetVisitInternalInternalVisitsVisitIdGetData,
  GetVisitInternalInternalVisitsVisitIdGetResponses,
  GetVisitInternalInternalVisitsVisitIdGetErrors,
  UpdateVisitInternalInternalVisitsVisitIdPutData,
  UpdateVisitInternalInternalVisitsVisitIdPutResponses,
  UpdateVisitInternalInternalVisitsVisitIdPutErrors,
  GetVisitDataInternalInternalVisitsVisitIdDataGetData,
  GetVisitDataInternalInternalVisitsVisitIdDataGetResponses,
  GetVisitDataInternalInternalVisitsVisitIdDataGetErrors,
  UpdateVisitDataInternalInternalVisitsVisitIdDataPutData,
  UpdateVisitDataInternalInternalVisitsVisitIdDataPutResponses,
  UpdateVisitDataInternalInternalVisitsVisitIdDataPutErrors,
  GenerateTestDataDevTestDataGeneratePostData,
  GenerateTestDataDevTestDataGeneratePostResponses,
  GenerateTestDataDevTestDataGeneratePostErrors,
  ClearTestDataDevTestDataClearDeleteData,
  ClearTestDataDevTestDataClearDeleteResponses,
  ClearTestDataDevTestDataClearDeleteErrors,
  RootGetData,
  RootGetResponses,
} from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = ClientOptions<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Trigger Error
 */
export const triggerErrorSentryDebugExceptionGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<TriggerErrorSentryDebugExceptionGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    TriggerErrorSentryDebugExceptionGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/sentry-debug/exception',
    ...options,
  });
};

/**
 * Log Error
 */
export const logErrorSentryDebugLogErrorGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<LogErrorSentryDebugLogErrorGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    LogErrorSentryDebugLogErrorGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/sentry-debug/log-error',
    ...options,
  });
};

/**
 * Health Check
 * Health check endpoint
 */
export const healthCheckHealthGet = <ThrowOnError extends boolean = false>(
  options?: Options<HealthCheckHealthGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    HealthCheckHealthGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/health',
    ...options,
  });
};

/**
 * Login
 * Redirect to WorkOS SSO login page.
 */
export const loginAuthLoginGet = <ThrowOnError extends boolean = false>(
  options?: Options<LoginAuthLoginGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    LoginAuthLoginGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/auth/login',
    ...options,
  });
};

/**
 * Auth Callback
 * Handle WorkOS authentication callback.
 */
export const authCallbackAuthCallbackGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AuthCallbackAuthCallbackGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    AuthCallbackAuthCallbackGetResponses,
    AuthCallbackAuthCallbackGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/auth/callback',
    ...options,
  });
};

/**
 * Logout
 * Logout user by clearing cookies and triggering WorkOS logout.
 */
export const logoutAuthLogoutGet = <ThrowOnError extends boolean = false>(
  options?: Options<LogoutAuthLogoutGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    LogoutAuthLogoutGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/auth/logout',
    ...options,
  });
};

/**
 * Get Current Ctx Info
 * Get current user information with agency details.
 */
export const getCurrentCtxInfoAuthMeGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetCurrentCtxInfoAuthMeGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetCurrentCtxInfoAuthMeGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/auth/me',
    ...options,
  });
};

/**
 * Get Widget Token
 * Get widget token for WorkOS widgets (e.g., OrganizationSwitcher).
 * Returns the access token from the current session.
 */
export const getWidgetTokenAuthWidgetTokenGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetWidgetTokenAuthWidgetTokenGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetWidgetTokenAuthWidgetTokenGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/auth/widget-token',
    ...options,
  });
};

/**
 * Switch Organization
 * Switch to a different organization.
 * Returns a redirect URL to re-authenticate with the new organization.
 */
export const switchOrganizationAuthSwitchOrganizationPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SwitchOrganizationAuthSwitchOrganizationPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    SwitchOrganizationAuthSwitchOrganizationPostResponses,
    SwitchOrganizationAuthSwitchOrganizationPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/auth/switch-organization',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get User Organizations
 * Get all organizations that the current user belongs to.
 * Used for the organization switcher to display available organizations.
 */
export const getUserOrganizationsAuthOrganizationsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetUserOrganizationsAuthOrganizationsGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetUserOrganizationsAuthOrganizationsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/auth/organizations',
    ...options,
  });
};

/**
 * Get Intakes For Auth Management
 * Get intake records for authorization management.
 * Returns intakes that need attention for:
 * - Missing eligibility check (no successful check in last 30 days)
 * - Missing prior authorization (requires_prior_auth=true but not VERIFIED)
 * - Pending review or under review status
 * - Accepted status (ready to admit)
 *
 * Excludes:
 * - Rejected intakes (not active for authorization management)
 * - Scheduled intakes that don't have eligibility or authorization issues
 *
 * If user has an agency, results are filtered to that agency.
 *
 * Args:
 * limit: Maximum number of records to return
 * offset: Number of records to skip
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * List of IntakeResponse objects
 */
export const getIntakesForAuthManagementAuthorizationGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetIntakesForAuthManagementAuthorizationGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetIntakesForAuthManagementAuthorizationGetResponses,
    GetIntakesForAuthManagementAuthorizationGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/',
    ...options,
  });
};

/**
 * Simulate Authorization Request
 * TEMPORARY: Simulate requesting authorization for an intake.
 *
 * This updates the intake's authorization status to PENDING and sets the request date.
 */
export const simulateAuthorizationRequestAuthorizationSimulateIntakeIdRequestPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SimulateAuthorizationRequestAuthorizationSimulateIntakeIdRequestPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      SimulateAuthorizationRequestAuthorizationSimulateIntakeIdRequestPostResponses,
      SimulateAuthorizationRequestAuthorizationSimulateIntakeIdRequestPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/authorization/simulate/{intake_id}/request',
      ...options,
    });
  };

/**
 * Simulate Authorization Approve
 * TEMPORARY: Simulate approving authorization for an intake.
 *
 * This updates the intake's authorization status to VERIFIED and generates an authorization number.
 */
export const simulateAuthorizationApproveAuthorizationSimulateIntakeIdApprovePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SimulateAuthorizationApproveAuthorizationSimulateIntakeIdApprovePostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      SimulateAuthorizationApproveAuthorizationSimulateIntakeIdApprovePostResponses,
      SimulateAuthorizationApproveAuthorizationSimulateIntakeIdApprovePostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/authorization/simulate/{intake_id}/approve',
      ...options,
    });
  };

/**
 * Simulate Authorization Deny
 * TEMPORARY: Simulate denying authorization for an intake.
 *
 * This updates the intake's authorization status to REJECTED.
 */
export const simulateAuthorizationDenyAuthorizationSimulateIntakeIdDenyPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SimulateAuthorizationDenyAuthorizationSimulateIntakeIdDenyPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    SimulateAuthorizationDenyAuthorizationSimulateIntakeIdDenyPostResponses,
    SimulateAuthorizationDenyAuthorizationSimulateIntakeIdDenyPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/authorization/simulate/{intake_id}/deny',
    ...options,
  });
};

/**
 * Simulate Authorization Clear
 * TEMPORARY: Simulate clearing authorization requirements for an intake.
 *
 * This sets requires_prior_auth to False and clears authorization status.
 */
export const simulateAuthorizationClearAuthorizationSimulateIntakeIdClearPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SimulateAuthorizationClearAuthorizationSimulateIntakeIdClearPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      SimulateAuthorizationClearAuthorizationSimulateIntakeIdClearPostResponses,
      SimulateAuthorizationClearAuthorizationSimulateIntakeIdClearPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/authorization/simulate/{intake_id}/clear',
      ...options,
    });
  };

/**
 * Get Users
 * Get all users with pagination
 */
export const getUsersUsersGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetUsersUsersGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetUsersUsersGetResponses,
    GetUsersUsersGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/',
    ...options,
  });
};

/**
 * Create User
 * Create a new user
 */
export const createUserUsersPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateUserUsersPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreateUserUsersPostResponses,
    CreateUserUsersPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Users By Workos Roles
 * Return users in the logged-in organization that have any of the given WorkOS roles.
 */
export const getUsersByWorkosRolesUsersByWorkosRolesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetUsersByWorkosRolesUsersByWorkosRolesPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    GetUsersByWorkosRolesUsersByWorkosRolesPostResponses,
    GetUsersByWorkosRolesUsersByWorkosRolesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/by-workos-roles',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete User
 * Delete a user
 */
export const deleteUserUsersUserIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteUserUsersUserIdDeleteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteUserUsersUserIdDeleteResponses,
    DeleteUserUsersUserIdDeleteErrors,
    ThrowOnError
  >({
    url: '/users/{user_id}',
    ...options,
  });
};

/**
 * Get User
 * Get a specific user by ID
 */
export const getUserUsersUserIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetUserUsersUserIdGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetUserUsersUserIdGetResponses,
    GetUserUsersUserIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}',
    ...options,
  });
};

/**
 * Update User
 * Update a user
 */
export const updateUserUsersUserIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateUserUsersUserIdPutData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateUserUsersUserIdPutResponses,
    UpdateUserUsersUserIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * List Org Members
 * List all members of the current WorkOS organization.
 *
 * For each member, includes their Roger User record (if it exists)
 * and all UserClinic assignments in the current agency.
 */
export const listOrgMembersUsersOrgMembersGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListOrgMembersUsersOrgMembersGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ListOrgMembersUsersOrgMembersGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/org-members',
    ...options,
  });
};

/**
 * Sync Clinic Assignments
 * Sync (set/replace) a user's clinic assignments within the current agency.
 *
 * - Assignments in the request that don't exist yet will be created.
 * - Existing assignments whose flags differ will be updated.
 * - Existing assignments not present in the request will be removed.
 */
export const syncClinicAssignmentsUsersUserIdClinicAssignmentsPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SyncClinicAssignmentsUsersUserIdClinicAssignmentsPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    SyncClinicAssignmentsUsersUserIdClinicAssignmentsPutResponses,
    SyncClinicAssignmentsUsersUserIdClinicAssignmentsPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}/clinic-assignments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Assign User To All Clinics
 * Assign the user to every clinic in the agency with the given default flags.
 *
 * - Already-existing assignments are updated with the provided flag values.
 * - Missing assignments are created.
 */
export const assignUserToAllClinicsUsersUserIdAssignAllClinicsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AssignUserToAllClinicsUsersUserIdAssignAllClinicsPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    AssignUserToAllClinicsUsersUserIdAssignAllClinicsPostResponses,
    AssignUserToAllClinicsUsersUserIdAssignAllClinicsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/users/{user_id}/assign-all-clinics',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get User Clinics
 * Get all user-clinic associations with pagination.
 */
export const getUserClinicsUserClinicsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetUserClinicsUserClinicsGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetUserClinicsUserClinicsGetResponses,
    GetUserClinicsUserClinicsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/user-clinics/',
    ...options,
  });
};

/**
 * Create User Clinic
 * Create a new user-clinic association.
 */
export const createUserClinicUserClinicsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateUserClinicUserClinicsPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreateUserClinicUserClinicsPostResponses,
    CreateUserClinicUserClinicsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/user-clinics/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete User Clinic
 * Delete a user-clinic association by ID.
 */
export const deleteUserClinicUserClinicsIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteUserClinicUserClinicsIdDeleteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteUserClinicUserClinicsIdDeleteResponses,
    DeleteUserClinicUserClinicsIdDeleteErrors,
    ThrowOnError
  >({
    url: '/user-clinics/{id}',
    ...options,
  });
};

/**
 * Get User Clinic
 * Get a specific user-clinic association by ID.
 */
export const getUserClinicUserClinicsIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetUserClinicUserClinicsIdGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetUserClinicUserClinicsIdGetResponses,
    GetUserClinicUserClinicsIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/user-clinics/{id}',
    ...options,
  });
};

/**
 * Get Clinics By User
 */
export const getClinicsByUserUserClinicsUserUserIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetClinicsByUserUserClinicsUserUserIdGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetClinicsByUserUserClinicsUserUserIdGetResponses,
    GetClinicsByUserUserClinicsUserUserIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/user-clinics/user/{user_id}',
    ...options,
  });
};

/**
 * Get Users By Clinic
 * Get all users assigned to a specific clinic.
 */
export const getUsersByClinicUserClinicsClinicClinicIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetUsersByClinicUserClinicsClinicClinicIdGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetUsersByClinicUserClinicsClinicClinicIdGetResponses,
    GetUsersByClinicUserClinicsClinicClinicIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/user-clinics/clinic/{clinic_id}',
    ...options,
  });
};

/**
 * Remove User From Clinic
 * Remove a user from a specific clinic.
 */
export const removeUserFromClinicUserClinicsUserUserIdClinicClinicIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RemoveUserFromClinicUserClinicsUserUserIdClinicClinicIdDeleteData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).delete<
    RemoveUserFromClinicUserClinicsUserUserIdClinicClinicIdDeleteResponses,
    RemoveUserFromClinicUserClinicsUserUserIdClinicClinicIdDeleteErrors,
    ThrowOnError
  >({
    url: '/user-clinics/user/{user_id}/clinic/{clinic_id}',
    ...options,
  });
};

/**
 * Add User To All Agency Clinics
 * Add a user to all clinics belonging to their agency.
 *
 * If agency_id is provided, adds user to all clinics of that agency.
 * If agency_id is not provided, finds the user's agency(ies) via their clinician
 * account and creates associations for all clinics in those agencies.
 */
export const addUserToAllAgencyClinicsUserClinicsUserUserIdAssignAllPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    AddUserToAllAgencyClinicsUserClinicsUserUserIdAssignAllPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    AddUserToAllAgencyClinicsUserClinicsUserUserIdAssignAllPostResponses,
    AddUserToAllAgencyClinicsUserClinicsUserUserIdAssignAllPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/user-clinics/user/{user_id}/assign-all',
    ...options,
  });
};

/**
 * Get Available Clinicians
 * Get available clinicians for the current context's agency. Raises error if no agency in context.
 */
export const getAvailableCliniciansUserClinicsAvailableGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetAvailableCliniciansUserClinicsAvailableGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAvailableCliniciansUserClinicsAvailableGetResponses,
    GetAvailableCliniciansUserClinicsAvailableGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/user-clinics/available',
    ...options,
  });
};

/**
 * Get Agencies
 * Get all agencies with pagination
 */
export const getAgenciesAgenciesGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetAgenciesAgenciesGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAgenciesAgenciesGetResponses,
    GetAgenciesAgenciesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agencies/',
    ...options,
  });
};

/**
 * Create Agency
 * Create a new agency
 */
export const createAgencyAgenciesPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateAgencyAgenciesPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreateAgencyAgenciesPostResponses,
    CreateAgencyAgenciesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agencies/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Agency
 * Delete an agency
 */
export const deleteAgencyAgenciesAgencyIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAgencyAgenciesAgencyIdDeleteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteAgencyAgenciesAgencyIdDeleteResponses,
    DeleteAgencyAgenciesAgencyIdDeleteErrors,
    ThrowOnError
  >({
    url: '/agencies/{agency_id}',
    ...options,
  });
};

/**
 * Get Agency
 * Get a specific agency by ID
 */
export const getAgencyAgenciesAgencyIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAgencyAgenciesAgencyIdGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetAgencyAgenciesAgencyIdGetResponses,
    GetAgencyAgenciesAgencyIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agencies/{agency_id}',
    ...options,
  });
};

/**
 * Update Agency
 * Update an agency
 */
export const updateAgencyAgenciesAgencyIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateAgencyAgenciesAgencyIdPutData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateAgencyAgenciesAgencyIdPutResponses,
    UpdateAgencyAgenciesAgencyIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agencies/{agency_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Agency Clinics
 * Get agency clinics with optional filtering by agency
 */
export const getAgencyClinicsAgencyClinicsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetAgencyClinicsAgencyClinicsGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAgencyClinicsAgencyClinicsGetResponses,
    GetAgencyClinicsAgencyClinicsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agency-clinics/',
    ...options,
  });
};

/**
 * Create Agency Clinic
 * Create a new agency clinic
 */
export const createAgencyClinicAgencyClinicsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateAgencyClinicAgencyClinicsPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreateAgencyClinicAgencyClinicsPostResponses,
    CreateAgencyClinicAgencyClinicsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agency-clinics/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Agency Clinic
 * Delete an agency clinic
 */
export const deleteAgencyClinicAgencyClinicsAgencyClinicIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteAgencyClinicAgencyClinicsAgencyClinicIdDeleteData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteAgencyClinicAgencyClinicsAgencyClinicIdDeleteResponses,
    DeleteAgencyClinicAgencyClinicsAgencyClinicIdDeleteErrors,
    ThrowOnError
  >({
    url: '/agency-clinics/{agency_clinic_id}',
    ...options,
  });
};

/**
 * Get Agency Clinic
 * Get a specific agency clinic by ID
 */
export const getAgencyClinicAgencyClinicsAgencyClinicIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAgencyClinicAgencyClinicsAgencyClinicIdGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetAgencyClinicAgencyClinicsAgencyClinicIdGetResponses,
    GetAgencyClinicAgencyClinicsAgencyClinicIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agency-clinics/{agency_clinic_id}',
    ...options,
  });
};

/**
 * Update Agency Clinic
 * Update an agency clinic
 */
export const updateAgencyClinicAgencyClinicsAgencyClinicIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateAgencyClinicAgencyClinicsAgencyClinicIdPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateAgencyClinicAgencyClinicsAgencyClinicIdPutResponses,
    UpdateAgencyClinicAgencyClinicsAgencyClinicIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agency-clinics/{agency_clinic_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Sync Clinics From Clinic Info
 * Sync AgencyClinic and AgencyInsurance records by fetching clinic information from RogerDoc API.
 *
 * This endpoint retrieves clinic information from the RogerDoc API and creates
 * or updates AgencyClinic and AgencyInsurance records in the database.
 * Clinic records are deduplicated based on clinic_key, and insurance records
 * are deduplicated based on clinic_key and insurance_key.
 *
 * Args:
 * request: FastAPI request object
 * ctx: Current context for authentication
 * db: Database session
 *
 * Returns:
 * Dictionary with sync results:
 * {
 * "clinics": {
 * "created_count": 5,
 * "updated_count": 2,
 * "skipped_count": 1,
 * "total_count": 8
 * },
 * "insurances": {
 * "created_count": 12,
 * "updated_count": 3,
 * "skipped_count": 2,
 * "total_count": 17
 * },
 * "message": "Clinics and insurances synced successfully"
 * }
 *
 * Raises:
 * HTTPException: If RogerDoc API is unavailable or database operations fail
 */
export const syncClinicsFromClinicInfoAgencyClinicsSyncFromClinicInfoPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    SyncClinicsFromClinicInfoAgencyClinicsSyncFromClinicInfoPostData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).post<
    SyncClinicsFromClinicInfoAgencyClinicsSyncFromClinicInfoPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/agency-clinics/sync-from-clinic-info',
    ...options,
  });
};

/**
 * Get Clinic Info
 * Retrieve clinic information from RogerDoc API for a specific agency.
 *
 * This endpoint fetches stored clinic information from the RogerDoc database
 * for the specified agency. If clinic_id is provided, returns only that clinic;
 * otherwise returns all clinics for the agency.
 *
 * Args:
 * agency_id: String identifier for the agency
 * clinic_id: Optional string identifier for a specific clinic
 * ctx: Current context for authentication
 *
 * Returns:
 * Dictionary containing clinic information with the following structure:
 * {
 * "agency_id": "string",
 * "clinic_id": "string",
 * "clinic_name": "string",
 * "auto_mrn": boolean,
 * "physicians": [...],
 * "clinicians": [...],
 * "clinical_care_managers": [...],
 * "case_managers": [...],
 * "oasis_approvers": [...],
 * "pt_approvers": [...],
 * "ot_approvers": [...],
 * "st_approvers": [...],
 * "primary_schedulers": [...],
 * "secondary_schedulers": [...],
 * "insurance_providers": [...],
 * "branches": [...]
 * }
 *
 * Raises:
 * HTTPException: If RogerDoc API is unavailable or request fails
 */
export const getClinicInfoClinicsInfoAgencyIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetClinicInfoClinicsInfoAgencyIdGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetClinicInfoClinicsInfoAgencyIdGetResponses,
    GetClinicInfoClinicsInfoAgencyIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/clinics/info/{agency_id}',
    ...options,
  });
};

/**
 * Scrape Clinic Info
 * Initiate web scraping of clinic information from Wellsky EMR system.
 *
 * This endpoint triggers scraping of clinic information from the Wellsky EMR
 * "New Patient" page. If save_to_db is True, the scraped data is saved to the
 * database and agency insurance records are created/updated.
 *
 * Args:
 * agency_id: Optional agency ID to scrape. If None, processes eligible agencies.
 * save_to_db: Whether to save scraped data to database (default: True)
 * ctx: Current context for authentication
 * db: Database session
 *
 * Returns:
 * Dictionary containing scraped clinic data and metadata:
 * {
 * "agency_id_1": {
 * "clinic_name_1": {clinic_data},
 * "clinic_name_2": {clinic_data}
 * },
 * "success": true,
 * "count": 15  // number of records saved (if save_to_db=True)
 * }
 *
 * Raises:
 * HTTPException: If scraping fails or database operations fail
 */
export const scrapeClinicInfoClinicsInfoScrapePost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ScrapeClinicInfoClinicsInfoScrapePostData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    ScrapeClinicInfoClinicsInfoScrapePostResponses,
    ScrapeClinicInfoClinicsInfoScrapePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/clinics/info/scrape',
    ...options,
  });
};

/**
 * Get Agency Insurances
 * Get agency insurance records.
 *
 * Retrieve insurance provider configurations for agencies. Can filter by
 * agency ID and/or clinic key.
 *
 * Args:
 * agency_id: Optional UUID to filter by specific agency
 * clinic_key: Optional clinic key to filter results
 * skip: Number of records to skip for pagination
 * limit: Optional maximum number of records to return (no limit if not specified)
 * ctx: Current context for authentication
 * db: Database session
 *
 * Returns:
 * List of agency insurance records
 */
export const getAgencyInsurancesClinicsInsuranceGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetAgencyInsurancesClinicsInsuranceGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAgencyInsurancesClinicsInsuranceGetResponses,
    GetAgencyInsurancesClinicsInsuranceGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/clinics/insurance',
    ...options,
  });
};

/**
 * Update Insurances From Clinic Info
 * Update agency insurance records based on clinic information.
 *
 * This endpoint creates new AgencyInsurance records for the current user's agency,
 * deduplicating based on name, edi_payer_id, clinic_key, and agency_id.
 * Existing records are preserved.
 *
 * Args:
 * clinic_info: List of clinic information dictionaries containing insurance_providers
 * ctx: Current context for authentication
 * db: Database session
 *
 * Returns:
 * Dictionary with update results:
 * {
 * "created_count": 12,
 * "skipped_count": 5,
 * "total_count": 17,
 * "message": "Insurance records updated successfully"
 * }
 *
 * Raises:
 * HTTPException: If database operations fail
 */
export const updateInsurancesFromClinicInfoClinicsInsuranceUpdateFromClinicInfoPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdateInsurancesFromClinicInfoClinicsInsuranceUpdateFromClinicInfoPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      UpdateInsurancesFromClinicInfoClinicsInsuranceUpdateFromClinicInfoPostResponses,
      UpdateInsurancesFromClinicInfoClinicsInsuranceUpdateFromClinicInfoPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/clinics/insurance/update-from-clinic-info',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Get Patients
 * Get all patients with optional search and pagination.
 * If user has an agency, results are filtered to that agency.
 * By default, only patients with at least one active episode are returned.
 * Set show_inactive=true to include all patients.
 */
export const getPatientsPatientsGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetPatientsPatientsGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetPatientsPatientsGetResponses,
    GetPatientsPatientsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/',
    ...options,
  });
};

/**
 * Create Patient
 * Create a new patient.
 * Admission and episode are NOT auto-created - they must be created separately
 * with a valid start date through the intake workflow or admission endpoint.
 */
export const createPatientPatientsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreatePatientPatientsPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreatePatientPatientsPostResponses,
    CreatePatientPatientsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Patient Count
 * Get total count of patients.
 * If user has an agency, count is filtered to that agency.
 */
export const getPatientCountPatientsCountGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetPatientCountPatientsCountGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetPatientCountPatientsCountGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/count',
    ...options,
  });
};

/**
 * Delete Patient
 * Delete a patient.
 * If user has an agency, verifies the patient belongs to that agency.
 */
export const deletePatientPatientsPatientIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeletePatientPatientsPatientIdDeleteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DeletePatientPatientsPatientIdDeleteResponses,
    DeletePatientPatientsPatientIdDeleteErrors,
    ThrowOnError
  >({
    url: '/patients/{patient_id}',
    ...options,
  });
};

/**
 * Get Patient
 * Get a specific patient by ID.
 * If user has an agency, verifies the patient belongs to that agency.
 */
export const getPatientPatientsPatientIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPatientPatientsPatientIdGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetPatientPatientsPatientIdGetResponses,
    GetPatientPatientsPatientIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}',
    ...options,
  });
};

/**
 * Update Patient
 * Update a patient.
 * If user has an agency, verifies the patient belongs to that agency.
 */
export const updatePatientPatientsPatientIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdatePatientPatientsPatientIdPutData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    UpdatePatientPatientsPatientIdPutResponses,
    UpdatePatientPatientsPatientIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Patient Visits
 * Get all visits for a patient (across all admissions/episodes).
 * If user has an agency, results are filtered to that agency.
 * Includes episode start and end dates for each visit.
 */
export const getPatientVisitsPatientsPatientIdVisitsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPatientVisitsPatientsPatientIdVisitsGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetPatientVisitsPatientsPatientIdVisitsGetResponses,
    GetPatientVisitsPatientsPatientIdVisitsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/visits',
    ...options,
  });
};

/**
 * Create Patient Visit
 * Create a new visit for a patient.
 *
 * The visit will be created for the most recent episode of the patient.
 * If no episode exists, returns an error - episodes must be created explicitly
 * with proper start dates through the intake workflow or admission endpoint.
 * If user has an agency, ensures the patient belongs to that agency.
 */
export const createPatientVisitPatientsPatientIdVisitsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreatePatientVisitPatientsPatientIdVisitsPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CreatePatientVisitPatientsPatientIdVisitsPostResponses,
    CreatePatientVisitPatientsPatientIdVisitsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/visits',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Patient Documents
 * Get all documents for a patient.
 * If user has an agency, verifies the patient belongs to that agency.
 */
export const getPatientDocumentsPatientsPatientIdDocumentsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientDocumentsPatientsPatientIdDocumentsGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetPatientDocumentsPatientsPatientIdDocumentsGetResponses,
    GetPatientDocumentsPatientsPatientIdDocumentsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/documents',
    ...options,
  });
};

/**
 * Upload Patient Document
 * Upload a new document for a patient.
 * If user has an agency, verifies the patient belongs to that agency.
 */
export const uploadPatientDocumentPatientsPatientIdDocumentsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UploadPatientDocumentPatientsPatientIdDocumentsPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    UploadPatientDocumentPatientsPatientIdDocumentsPostResponses,
    UploadPatientDocumentPatientsPatientIdDocumentsPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/patients/{patient_id}/documents',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });
};

/**
 * Get Patient Document Url
 * Get a presigned URL to view/download a specific patient document.
 * If user has an agency, verifies the patient belongs to that agency.
 */
export const getPatientDocumentUrlPatientsPatientIdDocumentsDocumentIdUrlGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientDocumentUrlPatientsPatientIdDocumentsDocumentIdUrlGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetPatientDocumentUrlPatientsPatientIdDocumentsDocumentIdUrlGetResponses,
    GetPatientDocumentUrlPatientsPatientIdDocumentsDocumentIdUrlGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/documents/{document_id}/url',
    ...options,
  });
};

/**
 * Update Patient Document
 * Update a patient document (e.g., rename).
 * If user has an agency, verifies the patient belongs to that agency.
 */
export const updatePatientDocumentPatientsPatientIdDocumentsDocumentIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdatePatientDocumentPatientsPatientIdDocumentsDocumentIdPatchData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdatePatientDocumentPatientsPatientIdDocumentsDocumentIdPatchResponses,
    UpdatePatientDocumentPatientsPatientIdDocumentsDocumentIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/documents/{document_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Import Waystar Csv Endpoint
 * Import payors from Waystar CSV file stored in S3.
 *
 * Downloads the CSV file from s3://roger-public-assets/waystar-payor-list.csv
 * and imports the payor data into the database.
 *
 * Returns:
 * Import results with counts and any errors
 */
export const importWaystarCsvEndpointPayorsImportWaystarCsvPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ImportWaystarCsvEndpointPayorsImportWaystarCsvPostData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).post<
    ImportWaystarCsvEndpointPayorsImportWaystarCsvPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payors/import-waystar-csv',
    ...options,
  });
};

/**
 * Import Stedi Csv Endpoint
 * Import payors from the latest Stedi payer network CSV.
 *
 * Downloads the CSV file directly from Stedi's payer network API
 * at https://www.stedi.com/healthcare/network and imports the
 * payor data into the database.
 *
 * Returns:
 * Import results with counts and any errors
 */
export const importStediCsvEndpointPayorsImportStediCsvPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ImportStediCsvEndpointPayorsImportStediCsvPostData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).post<
    ImportStediCsvEndpointPayorsImportStediCsvPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payors/import-stedi-csv',
    ...options,
  });
};

/**
 * Get Payors Endpoint
 * Get all payors, optionally filtered by type.
 *
 * Args:
 * db_session: Database session
 * payor_type: Optional filter by payor type
 *
 * Returns:
 * List of payor records
 */
export const getPayorsEndpointPayorsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetPayorsEndpointPayorsGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetPayorsEndpointPayorsGetResponses,
    GetPayorsEndpointPayorsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payors/',
    ...options,
  });
};

/**
 * Create Payor Endpoint
 * Create a new payor record.
 *
 * Args:
 * payor_data: Payor creation data
 * db_session: Database session
 *
 * Returns:
 * Created payor record
 *
 * Raises:
 * HTTPException: If payor with same name already exists
 */
export const createPayorEndpointPayorsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreatePayorEndpointPayorsPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreatePayorEndpointPayorsPostResponses,
    CreatePayorEndpointPayorsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payors/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Payor Endpoint
 * Delete a payor record.
 *
 * Args:
 * payor_id: Payor UUID
 * db_session: Database session
 *
 * Raises:
 * HTTPException: If payor not found
 */
export const deletePayorEndpointPayorsPayorIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeletePayorEndpointPayorsPayorIdDeleteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DeletePayorEndpointPayorsPayorIdDeleteResponses,
    DeletePayorEndpointPayorsPayorIdDeleteErrors,
    ThrowOnError
  >({
    url: '/payors/{payor_id}',
    ...options,
  });
};

/**
 * Get Payor Endpoint
 * Get a specific payor by ID.
 *
 * Args:
 * payor_id: Payor UUID
 * db_session: Database session
 *
 * Returns:
 * Payor record
 *
 * Raises:
 * HTTPException: If payor not found
 */
export const getPayorEndpointPayorsPayorIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPayorEndpointPayorsPayorIdGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetPayorEndpointPayorsPayorIdGetResponses,
    GetPayorEndpointPayorsPayorIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payors/{payor_id}',
    ...options,
  });
};

/**
 * Update Payor Endpoint
 * Update a payor record.
 *
 * Args:
 * payor_id: Payor UUID
 * payor_data: Payor update data
 * db_session: Database session
 *
 * Returns:
 * Updated payor record
 *
 * Raises:
 * HTTPException: If payor not found or validation fails
 */
export const updatePayorEndpointPayorsPayorIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdatePayorEndpointPayorsPayorIdPutData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    UpdatePayorEndpointPayorsPayorIdPutResponses,
    UpdatePayorEndpointPayorsPayorIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payors/{payor_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Payor By Name Endpoint
 * Get a payor by name.
 *
 * Args:
 * payor_name: Name of the payor
 * db_session: Database session
 *
 * Returns:
 * Payor record
 *
 * Raises:
 * HTTPException: If payor not found
 */
export const getPayorByNameEndpointPayorsByNamePayorNameGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPayorByNameEndpointPayorsByNamePayorNameGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetPayorByNameEndpointPayorsByNamePayorNameGetResponses,
    GetPayorByNameEndpointPayorsByNamePayorNameGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/payors/by-name/{payor_name}',
    ...options,
  });
};

/**
 * Get Payor By Electronic Id Endpoint
 * Get a payor by electronic payor ID.
 *
 * Args:
 * electronic_payor_id: Standardized industry identifier
 * db_session: Database session
 *
 * Returns:
 * Payor record
 *
 * Raises:
 * HTTPException: If payor not found
 */
export const getPayorByElectronicIdEndpointPayorsByElectronicIdElectronicPayorIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPayorByElectronicIdEndpointPayorsByElectronicIdElectronicPayorIdGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetPayorByElectronicIdEndpointPayorsByElectronicIdElectronicPayorIdGetResponses,
      GetPayorByElectronicIdEndpointPayorsByElectronicIdElectronicPayorIdGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/payors/by-electronic-id/{electronic_payor_id}',
      ...options,
    });
  };

/**
 * Get Payor By Clearinghouse Id Endpoint
 * Get a payor by clearinghouse payor ID.
 *
 * Args:
 * clearinghouse_payor_id: Clearinghouse-specific identifier
 * db_session: Database session
 *
 * Returns:
 * Payor record
 *
 * Raises:
 * HTTPException: If payor not found
 */
export const getPayorByClearinghouseIdEndpointPayorsByClearinghouseIdClearinghousePayorIdGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetPayorByClearinghouseIdEndpointPayorsByClearinghouseIdClearinghousePayorIdGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetPayorByClearinghouseIdEndpointPayorsByClearinghouseIdClearinghousePayorIdGetResponses,
      GetPayorByClearinghouseIdEndpointPayorsByClearinghouseIdClearinghousePayorIdGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/payors/by-clearinghouse-id/{clearinghouse_payor_id}',
      ...options,
    });
  };

/**
 * Get Eligibility Checks Endpoint
 * Get eligibility checks with optional filtering.
 *
 * Args:
 * db_session: Database session
 * intake_id: Optional filter by intake ID (preferred)
 * patient_id: Optional filter by patient ID (deprecated, kept for backward compatibility)
 * payor_id: Optional filter by payor ID
 * status: Optional filter by status
 *
 * Returns:
 * List of eligibility check records
 */
export const getEligibilityChecksEndpointEligibilityGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetEligibilityChecksEndpointEligibilityGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetEligibilityChecksEndpointEligibilityGetResponses,
    GetEligibilityChecksEndpointEligibilityGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/eligibility/',
    ...options,
  });
};

/**
 * Create Eligibility Check Endpoint
 * Create a new eligibility check request.
 *
 * Args:
 * eligibility_data: Eligibility check creation data
 * db_session: Database session
 *
 * Returns:
 * Created eligibility check record
 */
export const createEligibilityCheckEndpointEligibilityPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreateEligibilityCheckEndpointEligibilityPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CreateEligibilityCheckEndpointEligibilityPostResponses,
    CreateEligibilityCheckEndpointEligibilityPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/eligibility/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Eligibility Check Endpoint
 * Delete an eligibility check record.
 *
 * Args:
 * eligibility_id: Eligibility check UUID
 * db_session: Database session
 *
 * Raises:
 * HTTPException: If eligibility check not found
 */
export const deleteEligibilityCheckEndpointEligibilityEligibilityIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteEligibilityCheckEndpointEligibilityEligibilityIdDeleteData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteEligibilityCheckEndpointEligibilityEligibilityIdDeleteResponses,
    DeleteEligibilityCheckEndpointEligibilityEligibilityIdDeleteErrors,
    ThrowOnError
  >({
    url: '/eligibility/{eligibility_id}',
    ...options,
  });
};

/**
 * Get Eligibility Check Endpoint
 * Get a specific eligibility check by ID.
 *
 * Args:
 * eligibility_id: Eligibility check UUID
 * db_session: Database session
 *
 * Returns:
 * Eligibility check record
 *
 * Raises:
 * HTTPException: If eligibility check not found
 */
export const getEligibilityCheckEndpointEligibilityEligibilityIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetEligibilityCheckEndpointEligibilityEligibilityIdGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetEligibilityCheckEndpointEligibilityEligibilityIdGetResponses,
    GetEligibilityCheckEndpointEligibilityEligibilityIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/eligibility/{eligibility_id}',
    ...options,
  });
};

/**
 * Update Eligibility Check Endpoint
 * Update an eligibility check record.
 *
 * Args:
 * eligibility_id: Eligibility check UUID
 * eligibility_data: Eligibility check update data
 * db_session: Database session
 *
 * Returns:
 * Updated eligibility check record
 *
 * Raises:
 * HTTPException: If eligibility check not found
 */
export const updateEligibilityCheckEndpointEligibilityEligibilityIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateEligibilityCheckEndpointEligibilityEligibilityIdPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateEligibilityCheckEndpointEligibilityEligibilityIdPutResponses,
    UpdateEligibilityCheckEndpointEligibilityEligibilityIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/eligibility/{eligibility_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Complete Eligibility Check Endpoint
 * Mark an eligibility check as completed with response data.
 *
 * Args:
 * eligibility_id: Eligibility check UUID
 * eligibility_data: Completion data including effective_date, termination_date, etc.
 * db_session: Database session
 *
 * Returns:
 * Completed eligibility check record
 *
 * Raises:
 * HTTPException: If eligibility check not found
 */
export const completeEligibilityCheckEndpointEligibilityEligibilityIdCompletePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CompleteEligibilityCheckEndpointEligibilityEligibilityIdCompletePostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      CompleteEligibilityCheckEndpointEligibilityEligibilityIdCompletePostResponses,
      CompleteEligibilityCheckEndpointEligibilityEligibilityIdCompletePostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/eligibility/{eligibility_id}/complete',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Simulate Eligibility Check
 * TEMPORARY: Simulate creating an eligibility check for an intake.
 *
 * This creates a mock eligibility check with COMPLETED status for testing purposes.
 */
export const simulateEligibilityCheckEligibilitySimulateIntakeIdCheckPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SimulateEligibilityCheckEligibilitySimulateIntakeIdCheckPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    SimulateEligibilityCheckEligibilitySimulateIntakeIdCheckPostResponses,
    SimulateEligibilityCheckEligibilitySimulateIntakeIdCheckPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/eligibility/simulate/{intake_id}/check',
    ...options,
  });
};

/**
 * Simulate Eligibility Complete
 * TEMPORARY: Simulate completing an eligibility check for an intake.
 *
 * This finds the most recent eligibility check for the intake and marks it as completed.
 */
export const simulateEligibilityCompleteEligibilitySimulateIntakeIdCompletePost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      SimulateEligibilityCompleteEligibilitySimulateIntakeIdCompletePostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      SimulateEligibilityCompleteEligibilitySimulateIntakeIdCompletePostResponses,
      SimulateEligibilityCompleteEligibilitySimulateIntakeIdCompletePostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/eligibility/simulate/{intake_id}/complete',
      ...options,
    });
  };

/**
 * Simulate Eligibility Fail
 * TEMPORARY: Simulate failing an eligibility check for an intake.
 *
 * This finds the most recent eligibility check for the intake and marks it as failed.
 */
export const simulateEligibilityFailEligibilitySimulateIntakeIdFailPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SimulateEligibilityFailEligibilitySimulateIntakeIdFailPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    SimulateEligibilityFailEligibilitySimulateIntakeIdFailPostResponses,
    SimulateEligibilityFailEligibilitySimulateIntakeIdFailPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/eligibility/simulate/{intake_id}/fail',
    ...options,
  });
};

/**
 * Perform Real Eligibility Check
 * Perform a real eligibility check for an intake using Stedi API.
 *
 * This endpoint:
 * 1. Gets the intake and associated payor data
 * 2. Creates a Stedi eligibility request using intake demographics directly
 * 3. Submits the request to Stedi API
 * 4. Creates an eligibility check record linked to the intake
 * 5. Updates the intake with eligibility results
 *
 * Note: Patient records are NOT created during eligibility checks.
 * Patients are only created at the "Push to EMR" step.
 *
 * Args:
 * intake_id: Intake UUID
 * db_session: Database session
 * current_ctx: Current user context with agency information
 *
 * Returns:
 * Created/updated eligibility check record
 *
 * Raises:
 * HTTPException: If intake not found, payor not found, or API call fails
 */
export const performRealEligibilityCheckEligibilityIntakeIntakeIdCheckPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PerformRealEligibilityCheckEligibilityIntakeIntakeIdCheckPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    PerformRealEligibilityCheckEligibilityIntakeIntakeIdCheckPostResponses,
    PerformRealEligibilityCheckEligibilityIntakeIntakeIdCheckPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/eligibility/intake/{intake_id}/check',
    ...options,
  });
};

/**
 * Get Bucket Status
 * Get the status of the S3 bucket.
 */
export const getBucketStatusS3BucketStatusGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetBucketStatusS3BucketStatusGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetBucketStatusS3BucketStatusGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/s3/bucket/status',
    ...options,
  });
};

/**
 * Start Simple Workflow
 * Start a simple workflow.
 */
export const startSimpleWorkflowTemporalWorkflowSimplePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    StartSimpleWorkflowTemporalWorkflowSimplePostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    StartSimpleWorkflowTemporalWorkflowSimplePostResponses,
    StartSimpleWorkflowTemporalWorkflowSimplePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/temporal/workflow/simple',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Start Data Processing Workflow
 * Start a data processing workflow.
 */
export const startDataProcessingWorkflowTemporalWorkflowDataProcessingPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    StartDataProcessingWorkflowTemporalWorkflowDataProcessingPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    StartDataProcessingWorkflowTemporalWorkflowDataProcessingPostResponses,
    StartDataProcessingWorkflowTemporalWorkflowDataProcessingPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/temporal/workflow/data-processing',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Health Check
 * Health check endpoint for Temporal integration.
 */
export const healthCheckTemporalHealthGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<HealthCheckTemporalHealthGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    HealthCheckTemporalHealthGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/temporal/health',
    ...options,
  });
};

/**
 * Get Intake Form Schema
 * Get the intake form schema.
 *
 * Returns the JSON schema that defines the intake form structure,
 * field definitions, and validation rules. Used by the frontend
 * to dynamically render the intake form.
 *
 * Returns:
 * The intake form schema as a dict
 */
export const getIntakeFormSchemaIntakeFormSchemaGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetIntakeFormSchemaIntakeFormSchemaGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetIntakeFormSchemaIntakeFormSchemaGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/form-schema',
    ...options,
  });
};

/**
 * Get Intake Extraction Prompt
 * Get the current intake extraction prompt.
 *
 * Returns the LLM prompt used for extracting referral data from
 * intake documents, including field-specific instructions derived
 * from the intake schema.
 *
 * Returns:
 * Dict with 'prompt' key containing the extraction prompt
 */
export const getIntakeExtractionPromptIntakeExtractionPromptGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetIntakeExtractionPromptIntakeExtractionPromptGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetIntakeExtractionPromptIntakeExtractionPromptGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/extraction-prompt',
    ...options,
  });
};

/**
 * Upload File And Create Intake
 * Upload a file directly through the backend and create an intake record.
 *
 * This endpoint handles the file upload through the backend to avoid CORS issues
 * with direct S3 uploads.
 *
 * Args:
 * file: The uploaded file
 * trigger_parsing: Whether to trigger the referral parsing workflow
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * IntakeCreateFromUploadResponse with created intake and parsing status
 */
export const uploadFileAndCreateIntakeIntakeUploadPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UploadFileAndCreateIntakeIntakeUploadPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    UploadFileAndCreateIntakeIntakeUploadPostResponses,
    UploadFileAndCreateIntakeIntakeUploadPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/intake/upload',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });
};

/**
 * Upload Multiple Files And Create Intake
 * Upload multiple files and create a single intake record with multiple documents.
 *
 * This endpoint handles uploading multiple PDF files and creates one intake
 * with all documents attached.
 *
 * Args:
 * files: List of uploaded files
 * trigger_parsing: Whether to trigger the referral parsing workflow
 * parsing_strategy: Strategy for parsing multiple documents:
 * - "sequential": Process each document separately and merge results (default, processes all pages)
 * - "combined": Process all documents together in a single AI call
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * IntakeCreateFromUploadResponse with created intake and parsing status
 */
export const uploadMultipleFilesAndCreateIntakeIntakeUploadMultiplePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UploadMultipleFilesAndCreateIntakeIntakeUploadMultiplePostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    UploadMultipleFilesAndCreateIntakeIntakeUploadMultiplePostResponses,
    UploadMultipleFilesAndCreateIntakeIntakeUploadMultiplePostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/intake/upload-multiple',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });
};

/**
 * Get Auth Queue Endpoint
 * Get intakes that need prior authorization work.
 *
 * Returns intakes that:
 * - Are not rejected
 * - Have eligibility check result (insurance_verified = True)
 * - Require prior auth (requires_prior_auth = True)
 * - Don't yet have prior auth (authorization_status is None, empty, or 'PENDING')
 *
 * Args:
 * limit: Maximum number of records to return
 * offset: Number of records to skip
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * List of IntakeResponse objects needing prior auth
 */
export const getAuthQueueEndpointIntakeAuthQueueGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetAuthQueueEndpointIntakeAuthQueueGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAuthQueueEndpointIntakeAuthQueueGetResponses,
    GetAuthQueueEndpointIntakeAuthQueueGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/auth-queue',
    ...options,
  });
};

/**
 * Delete Intake Endpoint
 * Delete an intake record by ID.
 * NOTE: THIS CAN CURRENTLY BE TRIGGERED BY ANY USER. WILL ADD SECURITY AFTER WE
 * HAVE THE CONCEPT OF USER LOGIN IN FASTAPI.
 * Currently only verifies the intake belongs to that agency if user is authenticated
 *
 * This endpoint safely deletes:
 * - The intake record
 * - Related intake history records
 * - Related intake documents (and their S3 files)
 * - Related medications
 * - Cancels any running workflows
 *
 * Preserves:
 * - Created admissions (clears the intake reference)
 * - Patient records
 * - Payor records
 * - Agency records
 *
 * Args:
 * intake_id: Intake ID to delete
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Raises:
 * HTTPException: If intake not found or access denied
 */
export const deleteIntakeEndpointIntakeIntakeIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteIntakeEndpointIntakeIntakeIdDeleteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteIntakeEndpointIntakeIntakeIdDeleteResponses,
    DeleteIntakeEndpointIntakeIntakeIdDeleteErrors,
    ThrowOnError
  >({
    url: '/intake/{intake_id}',
    ...options,
  });
};

/**
 * Get Intake Endpoint
 * Get an intake record by ID.
 *
 * Args:
 * intake_id: Intake ID
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * IntakeResponse with intake data
 *
 * Raises:
 * HTTPException: If intake not found
 */
export const getIntakeEndpointIntakeIntakeIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetIntakeEndpointIntakeIntakeIdGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetIntakeEndpointIntakeIntakeIdGetResponses,
    GetIntakeEndpointIntakeIntakeIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}',
    ...options,
  });
};

/**
 * Update Intake Endpoint
 * Update an intake record.
 * If user has an agency, verifies the intake belongs to that agency.
 *
 * Args:
 * intake_id: Intake ID
 * intake_update: Intake update data
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * Updated IntakeResponse
 *
 * Raises:
 * HTTPException: If intake not found
 */
export const updateIntakeEndpointIntakeIntakeIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateIntakeEndpointIntakeIntakeIdPutData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateIntakeEndpointIntakeIntakeIdPutResponses,
    UpdateIntakeEndpointIntakeIntakeIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Intake Processing Status
 * Get the current processing status of an intake's workflow.
 *
 * This queries the running Temporal workflow (if active) to get real-time
 * status without polling the database. The workflow exposes current stage,
 * progress percentage, activity name, and any error messages.
 *
 * Args:
 * intake_id: UUID of the intake
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * Current processing status from the workflow, or fallback status
 * if workflow is not running
 *
 * Raises:
 * HTTPException: If intake not found or not authorized
 */
export const getIntakeProcessingStatusIntakeIntakeIdProcessingStatusGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetIntakeProcessingStatusIntakeIntakeIdProcessingStatusGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetIntakeProcessingStatusIntakeIntakeIdProcessingStatusGetResponses,
    GetIntakeProcessingStatusIntakeIntakeIdProcessingStatusGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/processing-status',
    ...options,
  });
};

/**
 * Get Intakes Endpoint
 * Get intake records with optional filtering and pagination.
 * If user has an agency, results are filtered to that agency.
 *
 * Args:
 * intake_status: Filter by intake status
 * patient_id: Filter by patient ID
 * search: Search term to filter by patient name, intake ID, or insurance
 * start_date: Start date filter (defaults to 6 weeks ago)
 * end_date: End date filter (defaults to today)
 * clinic_id: Filter by clinic ID (agency_clinic_id)
 * page: Page number (1-indexed)
 * per_page: Number of items per page (default 25, max 100)
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * IntakeListResponse with paginated intake data
 */
export const getIntakesEndpointIntakeGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetIntakesEndpointIntakeGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetIntakesEndpointIntakeGetResponses,
    GetIntakesEndpointIntakeGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/',
    ...options,
  });
};

/**
 * Initialize Emr Selection Endpoint
 * Initialize EMR selection when entering the Push to EMR step.
 *
 * This endpoint is called when a user navigates to the "Push to EMR" step.
 * If only one EMR option (Roger or Kinnser) is enabled via feature flags,
 * and no EMR selection has been made yet, it automatically sets the
 * appropriate push flag.
 *
 * This handles the case where:
 * - An agency didn't have feature flags enabled initially
 * - They had existing intakes
 * - Later the feature flag was enabled
 * - Going to "Push to EMR" step should auto-select the available option
 *
 * Args:
 * intake_id: Intake ID
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * IntakeResponse with potentially updated EMR selection flags
 *
 * Raises:
 * HTTPException: If intake not found or access denied
 */
export const initializeEmrSelectionEndpointIntakeIntakeIdInitializeEmrSelectionPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      InitializeEmrSelectionEndpointIntakeIntakeIdInitializeEmrSelectionPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      InitializeEmrSelectionEndpointIntakeIntakeIdInitializeEmrSelectionPostResponses,
      InitializeEmrSelectionEndpointIntakeIntakeIdInitializeEmrSelectionPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/intake/{intake_id}/initialize-emr-selection',
      ...options,
    });
  };

/**
 * Update Intake Fields Endpoint
 * Update specific fields in the intake's JSONB 'fields' column.
 * Merges updates with existing fields rather than replacing.
 *
 * Args:
 * intake_id: Intake ID
 * field_updates: Dictionary of field names and values to update
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * Updated IntakeResponse
 *
 * Raises:
 * HTTPException: If intake not found or access denied
 */
export const updateIntakeFieldsEndpointIntakeIntakeIdFieldsPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateIntakeFieldsEndpointIntakeIntakeIdFieldsPatchData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateIntakeFieldsEndpointIntakeIntakeIdFieldsPatchResponses,
    UpdateIntakeFieldsEndpointIntakeIntakeIdFieldsPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/fields',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Update Intake Status Endpoint
 * Update intake status and create history record.
 * If user has an agency, verifies the intake belongs to that agency.
 *
 * Args:
 * intake_id: Intake ID
 * status_update: Status update data
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * Success message
 *
 * Raises:
 * HTTPException: If intake not found
 */
export const updateIntakeStatusEndpointIntakeIntakeIdStatusPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateIntakeStatusEndpointIntakeIntakeIdStatusPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateIntakeStatusEndpointIntakeIntakeIdStatusPutResponses,
    UpdateIntakeStatusEndpointIntakeIntakeIdStatusPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/status',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Reject Intake Endpoint
 * Reject an intake with all required information in one atomic operation.
 *
 * This endpoint:
 * 1. Sets rejection_reason and rejection_details in the database
 * 2. Sets reviewed_date to current timestamp
 * 3. Sets reviewed_by to the current user
 * 4. Updates status to REJECTED
 *
 * Args:
 * intake_id: Intake ID
 * rejection_request: Rejection details
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * Success message with rejection details
 *
 * Raises:
 * HTTPException: If intake not found or access denied
 */
export const rejectIntakeEndpointIntakeIntakeIdRejectPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    RejectIntakeEndpointIntakeIntakeIdRejectPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    RejectIntakeEndpointIntakeIntakeIdRejectPutResponses,
    RejectIntakeEndpointIntakeIntakeIdRejectPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/reject',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Confirm Tab Status Endpoint
 * Confirm completion status for a specific intake workflow tab.
 *
 * This endpoint updates the tab_statuses JSONB field for a specific tab
 * and recomputes the global intake status based on the new tab statuses.
 *
 * Note: Tabs can be completed in any order. There is no enforced prerequisite
 * ordering - users may skip ahead or complete tabs out of sequence as needed
 * for their workflow.
 *
 * Special case: When push_to_emr tab is confirmed as 'complete', ALL tabs
 * are marked as complete (since the patient is now locked/created).
 *
 * Args:
 * intake_id: Intake ID
 * tab_key: Tab key (extraction, eligibility, prior_auth, ready_to_call, scheduling, push_to_emr)
 * tab_status_update: Status update data
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * Updated IntakeResponse
 *
 * Raises:
 * HTTPException: If intake not found or access denied
 */
export const confirmTabStatusEndpointIntakeIntakeIdTabTabKeyConfirmPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ConfirmTabStatusEndpointIntakeIntakeIdTabTabKeyConfirmPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    ConfirmTabStatusEndpointIntakeIntakeIdTabTabKeyConfirmPutResponses,
    ConfirmTabStatusEndpointIntakeIntakeIdTabTabKeyConfirmPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/tab/{tab_key}/confirm',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Referral Doc Presigned Url
 * Get a presigned S3 URL for the intake's referral document (PDF).
 * If user has an agency, verifies the intake belongs to that agency.
 *
 * Args:
 * intake_id: Intake ID
 * db_session: Database session
 * ctx: Current context with user and agency information
 * Returns:
 * dict: { 'url': <presigned_url> }
 * Raises:
 * HTTPException: If intake or PDF is missing
 */
export const getReferralDocPresignedUrlIntakeIntakeIdReferralDocGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetReferralDocPresignedUrlIntakeIntakeIdReferralDocGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetReferralDocPresignedUrlIntakeIntakeIdReferralDocGetResponses,
    GetReferralDocPresignedUrlIntakeIntakeIdReferralDocGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/referral-doc',
    ...options,
  });
};

/**
 * Get Referral Docs Presigned Urls
 * Get presigned S3 URLs for all of the intake's referral documents (PDFs).
 * If user has an agency, verifies the intake belongs to that agency.
 *
 * Args:
 * intake_id: Intake ID
 * db_session: Database session
 * ctx: Current context with user and agency information
 * Returns:
 * dict: { 'documents': [{ 'id': <doc_id>, 'file_name': <name>, 'url': <presigned_url> }, ...] }
 * Raises:
 * HTTPException: If intake is not found
 */
export const getReferralDocsPresignedUrlsIntakeIntakeIdReferralDocsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetReferralDocsPresignedUrlsIntakeIntakeIdReferralDocsGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetReferralDocsPresignedUrlsIntakeIntakeIdReferralDocsGetResponses,
    GetReferralDocsPresignedUrlsIntakeIntakeIdReferralDocsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/referral-docs',
    ...options,
  });
};

/**
 * Get Intake Documents Name Dict
 * Return a mapping of document upload names to display names for all documents
 * attached to the given intake. Upload name is the file path with the
 * referral_docs/ prefix stripped; display name is the document's file_name.
 */
export const getIntakeDocumentsNameDictIntakeIntakeIdDocumentsNameDictGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetIntakeDocumentsNameDictIntakeIntakeIdDocumentsNameDictGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetIntakeDocumentsNameDictIntakeIntakeIdDocumentsNameDictGetResponses,
    GetIntakeDocumentsNameDictIntakeIntakeIdDocumentsNameDictGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/documents/name_dict',
    ...options,
  });
};

/**
 * Update Intake Document
 * Update an intake document's metadata (e.g., display filename).
 *
 * Args:
 * document_id: Document ID
 * request: Update request containing new file_name
 * db_session: Database session
 * ctx: Current context with user and agency information
 * Returns:
 * IntakeDocumentResponse: Updated document data
 * Raises:
 * HTTPException: If document is not found or access denied
 */
export const updateIntakeDocumentIntakeDocumentsDocumentIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateIntakeDocumentIntakeDocumentsDocumentIdPatchData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateIntakeDocumentIntakeDocumentsDocumentIdPatchResponses,
    UpdateIntakeDocumentIntakeDocumentsDocumentIdPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/documents/{document_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Upload Document To Intake
 * Upload a new document to an existing intake.
 *
 * Documents uploaded via this endpoint are marked with used_in_extraction=False
 * since they were added after the initial extraction.
 *
 * Args:
 * intake_id: The intake ID to add the document to
 * file: The uploaded PDF file
 * display_name: Optional display name (defaults to original filename)
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * IntakeDocumentResponse: The created document record
 */
export const uploadDocumentToIntakeIntakeIntakeIdDocumentsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UploadDocumentToIntakeIntakeIntakeIdDocumentsPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    UploadDocumentToIntakeIntakeIntakeIdDocumentsPostResponses,
    UploadDocumentToIntakeIntakeIntakeIdDocumentsPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/intake/{intake_id}/documents',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });
};

/**
 * Trigger Ai Analysis Endpoint
 * Trigger AI analysis for an intake document.
 *
 * This endpoint starts a Temporal workflow to analyze the PDF document
 * associated with the intake and extract clinical insights.
 *
 * Args:
 * intake_id: ID of the intake to analyze
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * AIAnalysisResponse with workflow ID and status
 *
 * Raises:
 * HTTPException: If intake not found or analysis fails
 */
export const triggerAiAnalysisEndpointIntakeIntakeIdTriggerAiAnalysisPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    TriggerAiAnalysisEndpointIntakeIntakeIdTriggerAiAnalysisPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    TriggerAiAnalysisEndpointIntakeIntakeIdTriggerAiAnalysisPostResponses,
    TriggerAiAnalysisEndpointIntakeIntakeIdTriggerAiAnalysisPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/trigger-ai-analysis',
    ...options,
  });
};

/**
 * Reprocess Intake Endpoint
 * Re-trigger the referral parsing workflow for an existing intake.
 *
 * This endpoint allows reprocessing of an intake's documents without
 * re-uploading the files. It collects all existing document S3 keys
 * and starts a new IntakeReferralParsingWorkflow.
 *
 * Args:
 * intake_id: ID of the intake to reprocess
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * IntakeReprocessResponse with workflow ID and status
 *
 * Raises:
 * HTTPException: If intake not found or reprocessing fails
 */
export const reprocessIntakeEndpointIntakeIntakeIdReprocessPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ReprocessIntakeEndpointIntakeIntakeIdReprocessPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    ReprocessIntakeEndpointIntakeIntakeIdReprocessPostResponses,
    ReprocessIntakeEndpointIntakeIntakeIdReprocessPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/reprocess',
    ...options,
  });
};

/**
 * Get Ai Analysis Endpoint
 * Get AI analysis results for an intake.
 *
 * This endpoint fetches the results of a previously triggered AI analysis workflow.
 *
 * Args:
 * intake_id: ID of the intake
 * workflow_id: ID of the Temporal workflow
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * AIAnalysisResponse with analysis results
 *
 * Raises:
 * HTTPException: If intake not found or workflow not found
 */
export const getAiAnalysisEndpointIntakeIntakeIdAiAnalysisGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAiAnalysisEndpointIntakeIntakeIdAiAnalysisGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetAiAnalysisEndpointIntakeIntakeIdAiAnalysisGetResponses,
    GetAiAnalysisEndpointIntakeIntakeIdAiAnalysisGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/ai-analysis',
    ...options,
  });
};

/**
 * Get Episode Details Endpoint
 * Get episode and admission details for a scheduled intake.
 *
 * Args:
 * intake_id: ID of the intake
 * db_session: Database session
 * ctx: Current context with user and agency information
 *
 * Returns:
 * Dictionary with episode and admission details
 *
 * Raises:
 * HTTPException: If intake not found or not scheduled
 */
export const getEpisodeDetailsEndpointIntakeIntakeIdEpisodeDetailsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetEpisodeDetailsEndpointIntakeIntakeIdEpisodeDetailsGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetEpisodeDetailsEndpointIntakeIntakeIdEpisodeDetailsGetResponses,
    GetEpisodeDetailsEndpointIntakeIntakeIdEpisodeDetailsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/episode-details',
    ...options,
  });
};

/**
 * Onboard Patient Roger
 * Onboard a patient to Roger EMR using an intake ID.
 * This is the final step of the intake process.
 */
export const onboardPatientRogerIntakeIntakeIdOnboardPatientRogerPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    OnboardPatientRogerIntakeIntakeIdOnboardPatientRogerPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    OnboardPatientRogerIntakeIntakeIdOnboardPatientRogerPostResponses,
    OnboardPatientRogerIntakeIntakeIdOnboardPatientRogerPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/intake/{intake_id}/onboard_patient_roger',
    ...options,
  });
};

/**
 * Get Visits By Clinician
 * Get visits assigned to a specific clinician for the current agency.
 *
 * Args:
 * clinician_id: Clinician account UUID
 * db_session: Database session
 * ctx: Current context for agency-based access control
 * limit: Maximum number of visits to return
 * offset: Number of visits to skip for pagination
 *
 * Returns:
 * List of visits assigned to the clinician
 *
 * Raises:
 * HTTPException: If clinician not found or not accessible by current agency
 */
export const getVisitsByClinicianVisitsByClinicianClinicianIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetVisitsByClinicianVisitsByClinicianClinicianIdGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetVisitsByClinicianVisitsByClinicianClinicianIdGetResponses,
    GetVisitsByClinicianVisitsByClinicianClinicianIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/by-clinician/{clinician_id}',
    ...options,
  });
};

/**
 * Delete Visit
 * Delete a visit.
 *
 * Args:
 * visit_id: Visit UUID
 * db_session: Database session
 * ctx: Current context for agency-based access control
 *
 * Raises:
 * HTTPException: If visit not found or not accessible by current agency
 */
export const deleteVisitVisitsVisitIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteVisitVisitsVisitIdDeleteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteVisitVisitsVisitIdDeleteResponses,
    DeleteVisitVisitsVisitIdDeleteErrors,
    ThrowOnError
  >({
    url: '/visits/{visit_id}',
    ...options,
  });
};

/**
 * Get Visit
 * Get a specific visit by ID.
 *
 * Args:
 * visit_id: Visit UUID
 * db_session: Database session
 * ctx: Current context for agency-based access control
 *
 * Returns:
 * Visit details including visit_data and visit_data_last_updated
 *
 * Raises:
 * HTTPException: If visit not found or not accessible by current agency
 */
export const getVisitVisitsVisitIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetVisitVisitsVisitIdGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetVisitVisitsVisitIdGetResponses,
    GetVisitVisitsVisitIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}',
    ...options,
  });
};

/**
 * Update Visit
 * Update visit basic information.
 *
 * Args:
 * visit_id: Visit UUID
 * visit_update: Updated visit information
 * db_session: Database session
 * ctx: Current context for agency-based access control
 *
 * Returns:
 * Updated visit details
 *
 * Raises:
 * HTTPException: If visit not found or not accessible by current agency
 */
export const updateVisitVisitsVisitIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateVisitVisitsVisitIdPutData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateVisitVisitsVisitIdPutResponses,
    UpdateVisitVisitsVisitIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Create Visit
 * Create a new visit.
 *
 * Args:
 * visit_create: Visit creation data
 * db_session: Database session
 * ctx: Current context for agency-based access control
 *
 * Returns:
 * Created visit details
 *
 * Raises:
 * HTTPException: If episode not found or not accessible by current agency
 */
export const createVisitVisitsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateVisitVisitsPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreateVisitVisitsPostResponses,
    CreateVisitVisitsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Visit Data
 * Get only the visit_data for a specific visit.
 *
 * Args:
 * visit_id: Visit UUID
 * db_session: Database session
 * ctx: Current context for agency-based access control
 *
 * Returns:
 * Dictionary containing visit_data and visit_data_last_updated
 *
 * Raises:
 * HTTPException: If visit not found or not accessible by current agency
 */
export const getVisitDataVisitsVisitIdDataGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetVisitDataVisitsVisitIdDataGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetVisitDataVisitsVisitIdDataGetResponses,
    GetVisitDataVisitsVisitIdDataGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/data',
    ...options,
  });
};

/**
 * Update Visit Data
 * Update visit data with optimistic concurrency control.
 *
 * Uses visit_data_last_updated for optimistic locking to prevent concurrent edit conflicts.
 *
 * Args:
 * visit_id: Visit UUID
 * visit_update: Updated visit data and last updated timestamp
 * db_session: Database session
 * ctx: Current context for agency-based access control
 *
 * Returns:
 * Updated visit with new visit_data_last_updated timestamp
 *
 * Raises:
 * HTTPException: If visit not found, not accessible, or update is stale
 */
export const updateVisitDataVisitsVisitIdDataPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateVisitDataVisitsVisitIdDataPutData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateVisitDataVisitsVisitIdDataPutResponses,
    UpdateVisitDataVisitsVisitIdDataPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/visits/{visit_id}/data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Question Schema
 * Get the question schema from Roger Calls API.
 *
 * This schema is used to generate dynamic forms for visit data collection.
 *
 * Args:
 * visit_type: VisitTypeId to get schema for (must map to a RogerDocFormType)
 * ctx: Current context for authentication
 *
 * Returns:
 * Question schema dictionary from Roger Calls API
 *
 * Raises:
 * HTTPException: If visit type has no Roger Doc schema, API is unavailable,
 * or authentication fails
 */
export const getQuestionSchemaRogerdocQuestionSchemaGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetQuestionSchemaRogerdocQuestionSchemaGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetQuestionSchemaRogerdocQuestionSchemaGetResponses,
    GetQuestionSchemaRogerdocQuestionSchemaGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/question-schema',
    ...options,
  });
};

/**
 * Check Rogerdoc Health
 * Check if Roger-Doc service is available and authentication works.
 *
 * Returns:
 * Health status information
 */
export const checkRogerdocHealthRogerdocHealthGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<CheckRogerdocHealthRogerdocHealthGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    CheckRogerdocHealthRogerdocHealthGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/health',
    ...options,
  });
};

/**
 * Get Coding Upload Urls
 * Generate presigned URLs for uploading files for medical coding.
 *
 * Files are uploaded to the RogerDoc storage service which handles
 * bucket selection and presigned URL generation.
 *
 * Args:
 * request: List of files to generate upload URLs for
 * ctx: Current context for authentication
 *
 * Returns:
 * Presigned upload URLs for each file
 *
 * Raises:
 * HTTPException: If URL generation fails
 */
export const getCodingUploadUrlsRogerdocCodingUploadUrlsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetCodingUploadUrlsRogerdocCodingUploadUrlsPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    GetCodingUploadUrlsRogerdocCodingUploadUrlsPostResponses,
    GetCodingUploadUrlsRogerdocCodingUploadUrlsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/coding/upload-urls',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Upload Coding Files
 * Upload files for medical coding.
 *
 * Files are uploaded to the RogerDoc storage service. The backend handles
 * getting presigned URLs and uploading files to S3, avoiding CORS issues.
 *
 * All files are placed in a folder with a unique UUID:
 * roger_emr/{agency_id}/{folder_id}/{filename}
 *
 * Args:
 * files: List of files to upload
 * ctx: Current context for authentication
 *
 * Returns:
 * Upload results with S3 keys for each file
 *
 * Raises:
 * HTTPException: If upload fails
 */
export const uploadCodingFilesRogerdocCodingUploadFilesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UploadCodingFilesRogerdocCodingUploadFilesPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    UploadCodingFilesRogerdocCodingUploadFilesPostResponses,
    UploadCodingFilesRogerdocCodingUploadFilesPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/rogerdoc/coding/upload-files',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });
};

/**
 * Set Patient Info
 * Set patient info for medical coding.
 *
 * Starts a Temporal workflow that calls RogerDoc's /coding/set/patient-info endpoint.
 * Returns immediately with workflow_id for optional status polling.
 *
 * Args:
 * request: Patient and visit information with PDF paths
 * ctx: Current context for authentication
 *
 * Returns:
 * Response with workflow_id
 *
 * Raises:
 * HTTPException: If starting the workflow fails
 */
export const setPatientInfoRogerdocCodingSetPatientInfoPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    SetPatientInfoRogerdocCodingSetPatientInfoPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    SetPatientInfoRogerdocCodingSetPatientInfoPostResponses,
    SetPatientInfoRogerdocCodingSetPatientInfoPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/coding/set-patient-info',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Rogerdoc Vsp Update
 * Custom handler for VSP updates with audit logging.
 *
 * 1. Fetches current VSP state from RogerDoc
 * 2. Proxies the update request to RogerDoc
 * 3. On success, computes diff and creates audit log entry
 */
export const rogerdocVspUpdate = <ThrowOnError extends boolean = false>(
  options?: Options<RogerdocVspUpdateData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    RogerdocVspUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/vsp/update',
    ...options,
  });
};

/**
 * Rogerdoc Passthrough Delete
 * Passthrough DELETE request to RogerDoc API.
 */
export const rogerdocPassthroughDelete = <ThrowOnError extends boolean = false>(
  options: Options<RogerdocPassthroughDeleteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    RogerdocPassthroughDeleteResponses,
    RogerdocPassthroughDeleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/{path}',
    ...options,
  });
};

/**
 * Rogerdoc Passthrough Get
 * Passthrough GET request to RogerDoc API.
 */
export const rogerdocPassthroughGet = <ThrowOnError extends boolean = false>(
  options: Options<RogerdocPassthroughGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    RogerdocPassthroughGetResponses,
    RogerdocPassthroughGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/{path}',
    ...options,
  });
};

/**
 * Rogerdoc Passthrough Patch
 * Passthrough PATCH request to RogerDoc API.
 */
export const rogerdocPassthroughPatch = <ThrowOnError extends boolean = false>(
  options: Options<RogerdocPassthroughPatchData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    RogerdocPassthroughPatchResponses,
    RogerdocPassthroughPatchErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/{path}',
    ...options,
  });
};

/**
 * Rogerdoc Passthrough Post
 * Passthrough POST request to RogerDoc API.
 */
export const rogerdocPassthroughPost = <ThrowOnError extends boolean = false>(
  options: Options<RogerdocPassthroughPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    RogerdocPassthroughPostResponses,
    RogerdocPassthroughPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/{path}',
    ...options,
  });
};

/**
 * Rogerdoc Passthrough Put
 * Passthrough PUT request to RogerDoc API.
 */
export const rogerdocPassthroughPut = <ThrowOnError extends boolean = false>(
  options: Options<RogerdocPassthroughPutData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    RogerdocPassthroughPutResponses,
    RogerdocPassthroughPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/rogerdoc/api/{path}',
    ...options,
  });
};

/**
 * Generate X12 270
 * Generate X12 270 eligibility inquiry message.
 */
export const generateX12270X12270GeneratePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GenerateX12270X12270GeneratePostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    GenerateX12270X12270GeneratePostResponses,
    GenerateX12270X12270GeneratePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/x12/270/generate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Check Eligibility With X12 270
 * Generate X12 270 message and submit to Waystar for eligibility check.
 */
export const checkEligibilityWithX12270X12270EligibilityCheckPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CheckEligibilityWithX12270X12270EligibilityCheckPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CheckEligibilityWithX12270X12270EligibilityCheckPostResponses,
    CheckEligibilityWithX12270X12270EligibilityCheckPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/x12/270/eligibility-check',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Generate X12 271
 * Generate X12 271 eligibility response message.
 */
export const generateX12271X12271GeneratePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GenerateX12271X12271GeneratePostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    GenerateX12271X12271GeneratePostResponses,
    GenerateX12271X12271GeneratePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/x12/271/generate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Parse X12 271
 * Parse a raw X12 271 message and return the parsed response as JSON.
 */
export const parseX12271X12271ParsePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ParseX12271X12271ParsePostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ParseX12271X12271ParsePostResponses,
    ParseX12271X12271ParsePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/x12/271/parse',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Generate X12 837I
 * Generate X12 837I institutional healthcare claim message.
 */
export const generateX12837iX12837iGeneratePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GenerateX12837iX12837iGeneratePostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    GenerateX12837iX12837iGeneratePostResponses,
    GenerateX12837iX12837iGeneratePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/x12/837i/generate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Check Eligibility X12
 * Check eligibility using X12 270 message via Waystar.
 */
export const checkEligibilityX12WaystarEligibilityPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CheckEligibilityX12WaystarEligibilityPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CheckEligibilityX12WaystarEligibilityPostResponses,
    CheckEligibilityX12WaystarEligibilityPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/waystar/eligibility',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Check Eligibility Direct
 * Check eligibility directly via Waystar API.
 */
export const checkEligibilityDirectWaystarEligibilityDirectPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CheckEligibilityDirectWaystarEligibilityDirectPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CheckEligibilityDirectWaystarEligibilityDirectPostResponses,
    CheckEligibilityDirectWaystarEligibilityDirectPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/waystar/eligibility/direct',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Check Prior Authorization
 * Check prior authorization via Waystar API.
 */
export const checkPriorAuthorizationWaystarPriorAuthPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CheckPriorAuthorizationWaystarPriorAuthPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CheckPriorAuthorizationWaystarPriorAuthPostResponses,
    CheckPriorAuthorizationWaystarPriorAuthPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/waystar/prior-auth',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Submit Claim
 * Submit an X12 837i claim to Waystar via SFTP.
 */
export const submitClaimWaystarClaimsSubmit837iPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SubmitClaimWaystarClaimsSubmit837iPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    SubmitClaimWaystarClaimsSubmit837iPostResponses,
    SubmitClaimWaystarClaimsSubmit837iPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/waystar/claims/submit/837i',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Check Claim Acknowledgment
 * Check for 999 acknowledgment file for a submitted claim.
 */
export const checkClaimAcknowledgmentWaystarClaimsClaimIdAckGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CheckClaimAcknowledgmentWaystarClaimsClaimIdAckGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    CheckClaimAcknowledgmentWaystarClaimsClaimIdAckGetResponses,
    CheckClaimAcknowledgmentWaystarClaimsClaimIdAckGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/waystar/claims/{claim_id}/ack',
    ...options,
  });
};

/**
 * Check Eligibility
 * Submit a real-time eligibility check to Stedi.
 *
 * This endpoint accepts a request in Stedi's JSON format and returns
 * the eligibility response also in Stedi's JSON format.
 */
export const checkEligibilityStediEligibilityPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CheckEligibilityStediEligibilityPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CheckEligibilityStediEligibilityPostResponses,
    CheckEligibilityStediEligibilityPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/stedi/eligibility',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Check Coordination Of Benefits
 * Submit a coordination of benefits check to Stedi.
 *
 * This endpoint accepts a request in Stedi's JSON format (same as eligibility)
 * and returns the COB response from Stedi.
 */
export const checkCoordinationOfBenefitsStediCoordinationOfBenefitsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CheckCoordinationOfBenefitsStediCoordinationOfBenefitsPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CheckCoordinationOfBenefitsStediCoordinationOfBenefitsPostResponses,
    CheckCoordinationOfBenefitsStediCoordinationOfBenefitsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/stedi/coordination-of-benefits',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Submit Claim 837I
 * Submit an 837I institutional claim to Stedi.
 *
 * This endpoint implements a two-phase workflow:
 * 1. Create claim record in database with DRAFT status
 * 2. Submit to Stedi and update status to SUBMITTED on success
 *
 * Args:
 * request: 837I claim submission request data including patient_id and payor_id
 * db: Database session
 *
 * Returns:
 * 837I claim submission response from Stedi with database claim ID
 */
export const submitClaim837iStediClaim837iPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SubmitClaim837iStediClaim837iPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    SubmitClaim837iStediClaim837iPostResponses,
    SubmitClaim837iStediClaim837iPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/stedi/claim-837i',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Upload Claim Document For Patient
 * Upload a document for a patient that will be attached to a future claim.
 *
 * Args:
 * patient_id: Patient ID
 * file: File to upload (max 64MB)
 * report_type_code: PWK01 code (default: BM for attachments)
 * attachment_description: Description of the attachment
 * service_line_number: Optional service line number
 * provider_control_number: Optional provider control number
 * db: Database session
 * context: Current user context
 *
 * Returns:
 * ClaimDocumentResponse with attachment control number
 */
export const uploadClaimDocumentForPatientStediPatientsPatientIdClaimDocumentsPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UploadClaimDocumentForPatientStediPatientsPatientIdClaimDocumentsPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      UploadClaimDocumentForPatientStediPatientsPatientIdClaimDocumentsPostResponses,
      UploadClaimDocumentForPatientStediPatientsPatientIdClaimDocumentsPostErrors,
      ThrowOnError
    >({
      ...formDataBodySerializer,
      responseType: 'json',
      url: '/stedi/patients/{patient_id}/claim-documents',
      ...options,
      headers: {
        'Content-Type': null,
        ...options.headers,
      },
    });
  };

/**
 * Receive Stedi Webhook
 * Receive and process Stedi webhook events.
 *
 * This endpoint receives webhook notifications from Stedi for transaction processing events.
 * Currently, it only processes 277 (claim status) transactions.
 */
export const receiveStediWebhookStediWebhooksReceivePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ReceiveStediWebhookStediWebhooksReceivePostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    ReceiveStediWebhookStediWebhooksReceivePostResponses,
    ReceiveStediWebhookStediWebhooksReceivePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/stedi/webhooks/receive',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Create Patient In Kinnser
 * Create/push a patient to Kinnser from intake data.
 *
 * This endpoint validates the intake data and pushes it to Kinnser's system.
 * If validation fails, returns success=False with validation errors.
 *
 * Args:
 * request: Create request containing intake_id
 * db: Database session
 * context: Current user context
 *
 * Returns:
 * Response with success status and Kinnser patient ID if successful,
 * or validation errors if validation failed
 */
export const createPatientInKinnserKinnserPatientsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreatePatientInKinnserKinnserPatientsPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreatePatientInKinnserKinnserPatientsPostResponses,
    CreatePatientInKinnserKinnserPatientsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/kinnser/patients',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Onboard Patient
 * Onboard a patient with task and attachment in WellSky.
 *
 * This endpoint orchestrates three sequential operations:
 * 1. Creates a patient with a new episode
 * 2. Creates a task for that patient
 * 3. Uploads an attachment to that task
 *
 * Args:
 * clinic_id: The clinic ID where the patient will be created
 * branch_id: The branch ID where the patient will be created
 * request: Onboard request containing intake_id and task/upload fields
 * db: Database session
 * context: Current user context
 *
 * Returns:
 * Response with results from all three operations
 *
 * Raises:
 * HTTPException: If onboarding fails at any step
 */
export const onboardPatientKinnserPatientOnboardClinicIdBranchIdPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    OnboardPatientKinnserPatientOnboardClinicIdBranchIdPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    OnboardPatientKinnserPatientOnboardClinicIdBranchIdPostResponses,
    OnboardPatientKinnserPatientOnboardClinicIdBranchIdPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/kinnser/patient/onboard/{clinic_id}/{branch_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Kinnser Clinic Data
 * Get Kinnser clinic data for a specific clinic.
 *
 * Returns the clinic-specific Kinnser data including
 * physicians, clinicians, managers, approvers, and insurance providers.
 *
 * Args:
 * clinic_id: The ID of the clinic to get data for
 * context: Current user context
 *
 * Returns:
 * Clinic data with available options
 */
export const getKinnserClinicDataKinnserClinicsClinicIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetKinnserClinicDataKinnserClinicsClinicIdGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetKinnserClinicDataKinnserClinicsClinicIdGetResponses,
    GetKinnserClinicDataKinnserClinicsClinicIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/kinnser/clinics/{clinic_id}',
    ...options,
  });
};

/**
 * Get Kinnser Clinics
 * Get list of available Kinnser clinics.
 *
 * Returns the list of available clinics for dropdown selection.
 *
 * Args:
 * context: Current user context
 *
 * Returns:
 * Response with list of available clinics
 */
export const getKinnserClinicsKinnserClinicsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetKinnserClinicsKinnserClinicsGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    GetKinnserClinicsKinnserClinicsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/kinnser/clinics',
    ...options,
  });
};

/**
 * Search Allergies
 * Search allergies by name or get all allergies.
 * Defaults to ignoring user-defined allergies unless specified otherwise.
 */
export const searchAllergiesAllergiesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<SearchAllergiesAllergiesGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    SearchAllergiesAllergiesGetResponses,
    SearchAllergiesAllergiesGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/allergies/',
    ...options,
  });
};

/**
 * Create Allergy
 * Create a new allergy.
 */
export const createAllergyAllergiesPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateAllergyAllergiesPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreateAllergyAllergiesPostResponses,
    CreateAllergyAllergiesPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/allergies/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get User Defined Allergies
 * Get all user-defined allergies.
 */
export const getUserDefinedAllergiesAllergiesUserDefinedGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetUserDefinedAllergiesAllergiesUserDefinedGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetUserDefinedAllergiesAllergiesUserDefinedGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/allergies/user-defined',
    ...options,
  });
};

/**
 * Import Allergies From File
 * Import allergies from the hardcoded data file.
 * File format: allergy_name|num|letter|<br> (one per line).
 * Uses CRUD to create allergies; skips duplicates.
 */
export const importAllergiesFromFileAllergiesImportPost = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    ImportAllergiesFromFileAllergiesImportPostData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).post<
    ImportAllergiesFromFileAllergiesImportPostResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/allergies/import',
    ...options,
  });
};

/**
 * Delete Allergy
 * Delete an allergy.
 */
export const deleteAllergyAllergiesAllergyIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAllergyAllergiesAllergyIdDeleteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteAllergyAllergiesAllergyIdDeleteResponses,
    DeleteAllergyAllergiesAllergyIdDeleteErrors,
    ThrowOnError
  >({
    url: '/allergies/{allergy_id}',
    ...options,
  });
};

/**
 * Get Allergy
 * Get a specific allergy by ID.
 */
export const getAllergyAllergiesAllergyIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAllergyAllergiesAllergyIdGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetAllergyAllergiesAllergyIdGetResponses,
    GetAllergyAllergiesAllergyIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/allergies/{allergy_id}',
    ...options,
  });
};

/**
 * Get Patient Allergies
 * Get all allergies for a specific patient.
 */
export const getPatientAllergiesPatientsPatientIdAllergyGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientAllergiesPatientsPatientIdAllergyGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetPatientAllergiesPatientsPatientIdAllergyGetResponses,
    GetPatientAllergiesPatientsPatientIdAllergyGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/allergy',
    ...options,
  });
};

/**
 * Create Patient Allergy
 * Add an allergy to a patient.
 * Accepts allergy_id and reaction.
 */
export const createPatientAllergyPatientsPatientIdAllergyPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreatePatientAllergyPatientsPatientIdAllergyPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CreatePatientAllergyPatientsPatientIdAllergyPostResponses,
    CreatePatientAllergyPatientsPatientIdAllergyPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/allergy',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Create User Defined Patient Allergy
 * Create and add a user-defined allergy to a patient.
 * Accepts allergy_name and reaction.
 * If allergy_name doesn't exist, it creates a new user-defined allergy.
 */
export const createUserDefinedPatientAllergyPatientsPatientIdAllergyUserDefinedPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      CreateUserDefinedPatientAllergyPatientsPatientIdAllergyUserDefinedPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      CreateUserDefinedPatientAllergyPatientsPatientIdAllergyUserDefinedPostResponses,
      CreateUserDefinedPatientAllergyPatientsPatientIdAllergyUserDefinedPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/allergy/user-defined',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Delete Patient Allergy
 * Delete a patient allergy entry.
 */
export const deletePatientAllergyPatientsAllergyPatientAllergyIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeletePatientAllergyPatientsAllergyPatientAllergyIdDeleteData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).delete<
    DeletePatientAllergyPatientsAllergyPatientAllergyIdDeleteResponses,
    DeletePatientAllergyPatientsAllergyPatientAllergyIdDeleteErrors,
    ThrowOnError
  >({
    url: '/patients/allergy/{patient_allergy_id}',
    ...options,
  });
};

/**
 * Search Medications Endpoint
 * Search and list medications with optional filters.
 *
 * Supports text search on medication name and generic name,
 * plus filters for form, route, therapeutic category, and DEA schedule.
 * Results are paginated.
 *
 * Returns:
 * Paginated list of medications with total count
 */
export const searchMedicationsEndpointMedicationsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<SearchMedicationsEndpointMedicationsGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    SearchMedicationsEndpointMedicationsGetResponses,
    SearchMedicationsEndpointMedicationsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/medications/',
    ...options,
  });
};

/**
 * Get Medication Forms Endpoint
 * Get distinct medication forms for filter dropdowns.
 *
 * Returns:
 * List of unique drug forms
 */
export const getMedicationFormsEndpointMedicationsFormsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetMedicationFormsEndpointMedicationsFormsGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetMedicationFormsEndpointMedicationsFormsGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/medications/forms',
    ...options,
  });
};

/**
 * Get Medication Routes Endpoint
 * Get distinct medication routes for filter dropdowns.
 *
 * Returns:
 * List of unique routes of administration
 */
export const getMedicationRoutesEndpointMedicationsRoutesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetMedicationRoutesEndpointMedicationsRoutesGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetMedicationRoutesEndpointMedicationsRoutesGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/medications/routes',
    ...options,
  });
};

/**
 * Get Medication Categories Endpoint
 * Get distinct therapeutic categories for filter dropdowns.
 *
 * Returns:
 * List of unique therapeutic categories
 */
export const getMedicationCategoriesEndpointMedicationsCategoriesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetMedicationCategoriesEndpointMedicationsCategoriesGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? _heyApiClient).get<
    GetMedicationCategoriesEndpointMedicationsCategoriesGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/medications/categories',
    ...options,
  });
};

/**
 * Get Medication Endpoint
 * Get a specific medication by ID.
 *
 * Args:
 * medication_id: Medication UUID
 *
 * Returns:
 * Medication record
 *
 * Raises:
 * HTTPException: If medication not found
 */
export const getMedicationEndpointMedicationsMedicationIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetMedicationEndpointMedicationsMedicationIdGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetMedicationEndpointMedicationsMedicationIdGetResponses,
    GetMedicationEndpointMedicationsMedicationIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/medications/{medication_id}',
    ...options,
  });
};

/**
 * Get Patient Medications
 * Get all medications for a patient.
 *
 * Optionally filter out discontinued medications with include_discontinued=false.
 */
export const getPatientMedicationsPatientsPatientIdMedicationsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientMedicationsPatientsPatientIdMedicationsGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetPatientMedicationsPatientsPatientIdMedicationsGetResponses,
    GetPatientMedicationsPatientsPatientIdMedicationsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/medications/',
    ...options,
  });
};

/**
 * Create Patient Medication
 * Create a new medication for a patient.
 *
 * For on-market medications, provide medication_id.
 * For off-market medications, set is_off_market=true and provide off_market_description.
 */
export const createPatientMedicationPatientsPatientIdMedicationsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    CreatePatientMedicationPatientsPatientIdMedicationsPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).post<
    CreatePatientMedicationPatientsPatientIdMedicationsPostResponses,
    CreatePatientMedicationPatientsPatientIdMedicationsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/medications/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Delete Patient Medication
 * Delete a medication.
 */
export const deletePatientMedicationPatientsPatientIdMedicationsMedicationIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeletePatientMedicationPatientsPatientIdMedicationsMedicationIdDeleteData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).delete<
      DeletePatientMedicationPatientsPatientIdMedicationsMedicationIdDeleteResponses,
      DeletePatientMedicationPatientsPatientIdMedicationsMedicationIdDeleteErrors,
      ThrowOnError
    >({
      url: '/patients/{patient_id}/medications/{medication_id}',
      ...options,
    });
  };

/**
 * Get Patient Medication
 * Get a specific medication by ID.
 */
export const getPatientMedicationPatientsPatientIdMedicationsMedicationIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetPatientMedicationPatientsPatientIdMedicationsMedicationIdGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetPatientMedicationPatientsPatientIdMedicationsMedicationIdGetResponses,
    GetPatientMedicationPatientsPatientIdMedicationsMedicationIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/patients/{patient_id}/medications/{medication_id}',
    ...options,
  });
};

/**
 * Update Patient Medication
 * Update a medication.
 */
export const updatePatientMedicationPatientsPatientIdMedicationsMedicationIdPut =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UpdatePatientMedicationPatientsPatientIdMedicationsMedicationIdPutData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).put<
      UpdatePatientMedicationPatientsPatientIdMedicationsMedicationIdPutResponses,
      UpdatePatientMedicationPatientsPatientIdMedicationsMedicationIdPutErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/medications/{medication_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  };

/**
 * Get Medication Profile Attachments
 * Get all medication profile attachments for a patient.
 */
export const getMedicationProfileAttachmentsPatientsPatientIdMedicationsAttachmentsGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetMedicationProfileAttachmentsPatientsPatientIdMedicationsAttachmentsGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetMedicationProfileAttachmentsPatientsPatientIdMedicationsAttachmentsGetResponses,
      GetMedicationProfileAttachmentsPatientsPatientIdMedicationsAttachmentsGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/medications/attachments/',
      ...options,
    });
  };

/**
 * Upload Medication Profile Attachment
 * Upload a new attachment to the patient's medication profile.
 */
export const uploadMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsPost =
  <ThrowOnError extends boolean = false>(
    options: Options<
      UploadMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsPostData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).post<
      UploadMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsPostResponses,
      UploadMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsPostErrors,
      ThrowOnError
    >({
      ...formDataBodySerializer,
      responseType: 'json',
      url: '/patients/{patient_id}/medications/attachments/',
      ...options,
      headers: {
        'Content-Type': null,
        ...options.headers,
      },
    });
  };

/**
 * Get Medication Attachment Url
 * Get a presigned URL to download an attachment.
 */
export const getMedicationAttachmentUrlPatientsPatientIdMedicationsAttachmentsAttachmentIdUrlGet =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetMedicationAttachmentUrlPatientsPatientIdMedicationsAttachmentsAttachmentIdUrlGetData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).get<
      GetMedicationAttachmentUrlPatientsPatientIdMedicationsAttachmentsAttachmentIdUrlGetResponses,
      GetMedicationAttachmentUrlPatientsPatientIdMedicationsAttachmentsAttachmentIdUrlGetErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/patients/{patient_id}/medications/attachments/{attachment_id}/url',
      ...options,
    });
  };

/**
 * Delete Medication Profile Attachment
 * Delete a medication profile attachment.
 */
export const deleteMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsAttachmentIdDelete =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsAttachmentIdDeleteData,
      ThrowOnError
    >
  ) => {
    return (options.client ?? _heyApiClient).delete<
      DeleteMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsAttachmentIdDeleteResponses,
      DeleteMedicationProfileAttachmentPatientsPatientIdMedicationsAttachmentsAttachmentIdDeleteErrors,
      ThrowOnError
    >({
      url: '/patients/{patient_id}/medications/attachments/{attachment_id}',
      ...options,
    });
  };

/**
 * Internal Health Check
 * Health check endpoint for internal service communication.
 *
 * This endpoint is specifically for Roger Doc to verify RogerEMR API connectivity.
 */
export const internalHealthCheckInternalHealthGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<InternalHealthCheckInternalHealthGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    InternalHealthCheckInternalHealthGetResponses,
    InternalHealthCheckInternalHealthGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/health',
    ...options,
  });
};

/**
 * Sync Clinics From Clinic Info Internal
 * Sync AgencyClinic and AgencyInsurance records by fetching clinic information from RogerDoc API.
 *
 * This is the internal version of the sync endpoint that uses internal API key authentication.
 * If agency_system_name is provided, syncs only that agency. Otherwise, syncs all agencies.
 *
 * Args:
 * agency_system_name: Optional system name of the agency to sync. If None, syncs all agencies.
 * ctx: Current context from internal service authentication
 * db: Database session
 *
 * Returns:
 * SyncClinicInfoResponse for single agency, or BulkSyncResponse for all agencies
 *
 * Raises:
 * HTTPException: If agency not found, RogerDoc API is unavailable, or database operations fail
 */
export const syncClinicsFromClinicInfoInternalInternalAgencyClinicsSyncFromClinicInfoPost =
  <ThrowOnError extends boolean = false>(
    options?: Options<
      SyncClinicsFromClinicInfoInternalInternalAgencyClinicsSyncFromClinicInfoPostData,
      ThrowOnError
    >
  ) => {
    return (options?.client ?? _heyApiClient).post<
      SyncClinicsFromClinicInfoInternalInternalAgencyClinicsSyncFromClinicInfoPostResponses,
      SyncClinicsFromClinicInfoInternalInternalAgencyClinicsSyncFromClinicInfoPostErrors,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/internal/agency-clinics/sync-from-clinic-info',
      ...options,
    });
  };

/**
 * Get Visits List Internal
 * Get list of visits for the authenticated user within date range (internal service authentication).
 *
 * This endpoint is specifically designed for Roger Doc to fetch scheduled visits
 * for a clinician within a specified date range.
 *
 * Args:
 * start_date: Start date in YYYY-MM-DD format
 * end_date: End date in YYYY-MM-DD format
 * db_session: Database session
 * ctx: Current context from internal service authentication
 *
 * Returns:
 * Dictionary containing visits array for the date range
 *
 * Raises:
 * HTTPException: If dates are invalid or no access to visits
 */
export const getVisitsListInternalInternalVisitsGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetVisitsListInternalInternalVisitsGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetVisitsListInternalInternalVisitsGetResponses,
    GetVisitsListInternalInternalVisitsGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/visits',
    ...options,
  });
};

/**
 * Create Visit Internal
 * Create a new visit (internal service authentication).
 *
 * Args:
 * visit_create: Visit creation data
 * db_session: Database session
 * ctx: Current context from internal service authentication
 *
 * Returns:
 * Created visit details
 *
 * Raises:
 * HTTPException: If episode not found or not accessible by current agency
 */
export const createVisitInternalInternalVisitsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateVisitInternalInternalVisitsPostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CreateVisitInternalInternalVisitsPostResponses,
    CreateVisitInternalInternalVisitsPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/visits',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Visit Internal
 * Get a specific visit by ID (internal service authentication).
 *
 * Args:
 * visit_id: Visit UUID
 * db_session: Database session
 * ctx: Current context from internal service authentication
 *
 * Returns:
 * Visit details including visit_data and visit_data_last_updated
 *
 * Raises:
 * HTTPException: If visit not found or not accessible by current agency
 */
export const getVisitInternalInternalVisitsVisitIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetVisitInternalInternalVisitsVisitIdGetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetVisitInternalInternalVisitsVisitIdGetResponses,
    GetVisitInternalInternalVisitsVisitIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/visits/{visit_id}',
    ...options,
  });
};

/**
 * Update Visit Internal
 * Update visit basic information (internal service authentication).
 *
 * Args:
 * visit_id: Visit UUID
 * visit_update: Updated visit information
 * db_session: Database session
 * ctx: Current context from internal service authentication
 *
 * Returns:
 * Updated visit details
 *
 * Raises:
 * HTTPException: If visit not found or not accessible by current agency
 */
export const updateVisitInternalInternalVisitsVisitIdPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateVisitInternalInternalVisitsVisitIdPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateVisitInternalInternalVisitsVisitIdPutResponses,
    UpdateVisitInternalInternalVisitsVisitIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/visits/{visit_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Get Visit Data Internal
 * Get only the visit_data for a specific visit (internal service authentication).
 *
 * This endpoint is specifically designed for Roger Doc to fetch existing form data
 * before processing new voice recordings.
 *
 * Args:
 * visit_id: Visit UUID
 * db_session: Database session
 * ctx: Current context from internal service authentication
 *
 * Returns:
 * Dictionary containing visit_data and visit_data_last_updated
 *
 * Raises:
 * HTTPException: If visit not found or not accessible by current agency
 */
export const getVisitDataInternalInternalVisitsVisitIdDataGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetVisitDataInternalInternalVisitsVisitIdDataGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    GetVisitDataInternalInternalVisitsVisitIdDataGetResponses,
    GetVisitDataInternalInternalVisitsVisitIdDataGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/visits/{visit_id}/data',
    ...options,
  });
};

/**
 * Update Visit Data Internal
 * Update visit data with optimistic concurrency control (internal service authentication).
 *
 * This endpoint is specifically designed for Roger Doc to submit form responses
 * after AI processing of voice recordings.
 *
 * Uses visit_data_last_updated for optimistic locking to prevent concurrent edit conflicts.
 *
 * Args:
 * visit_id: Visit UUID
 * visit_update: Updated visit data and last updated timestamp
 * db_session: Database session
 * ctx: Current context from internal service authentication
 *
 * Returns:
 * Updated visit with new visit_data_last_updated timestamp
 *
 * Raises:
 * HTTPException: If visit not found, not accessible, or update is stale
 */
export const updateVisitDataInternalInternalVisitsVisitIdDataPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateVisitDataInternalInternalVisitsVisitIdDataPutData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateVisitDataInternalInternalVisitsVisitIdDataPutResponses,
    UpdateVisitDataInternalInternalVisitsVisitIdDataPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/internal/visits/{visit_id}/data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Generate Test Data
 * Generate test data for a specific agency.
 *
 * Creates patients, admissions, episodes, and visits.
 * Test patients are marked with a special email pattern for later deletion.
 *
 * SECURITY WARNING: This endpoint is only available in non-production environments!
 *
 * Note: Clinicians are NOT created or assigned. This data is for testing
 * patient/admission/episode/visit viewing functionality only.
 */
export const generateTestDataDevTestDataGeneratePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GenerateTestDataDevTestDataGeneratePostData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    GenerateTestDataDevTestDataGeneratePostResponses,
    GenerateTestDataDevTestDataGeneratePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/dev/test-data/generate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Clear Test Data
 * Clear test data for a specific agency.
 *
 * Identifies test patients by their email pattern (test-*@test.roger-emr.internal)
 * and deletes them along with all associated data (admissions, episodes, visits).
 *
 * SECURITY WARNING: This endpoint is only available in non-production environments!
 */
export const clearTestDataDevTestDataClearDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ClearTestDataDevTestDataClearDeleteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    ClearTestDataDevTestDataClearDeleteResponses,
    ClearTestDataDevTestDataClearDeleteErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/dev/test-data/clear',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Root
 * Root endpoint
 */
export const rootGet = <ThrowOnError extends boolean = false>(
  options?: Options<RootGetData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    RootGetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/',
    ...options,
  });
};
